webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(242),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(244),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(251),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2bd446db",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(230),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10e80970",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

/* eslint-disable */
module.exports = {
  request: function request(req, token) {

    if (req.url == 'api/token/verify/') {
      req.data.token = token;
    }

    this.options.http._setHeaders.call(this, req, { Authorization: "JWT " + token });
  },
  response: function response(res) {
    if (res.data.token) {
      return res.data.token;
    }
  }
};

/***/ }),
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(214)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(254),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(205)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-547762ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(256),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(207)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(247),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6207fc5b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(229),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10abc176",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(215)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(255),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(233),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(200)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-400a5227",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(194)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29af526a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13c77c2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(253),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b5c420ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f8f9dc8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ad6ccc2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-89671b9a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(209)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(249),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7641b69d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(203)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(243),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4c3cb1ad",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(246),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5d647033",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1e75537d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(236),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d93f36f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Auth__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_flatpickr_component__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_flatpickr_css__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_products_Products__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_products_Products___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_products_Products__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pharmacy_Pharmacies__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pharmacy_Pharmacies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_pharmacy_Pharmacies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pharmacy_Pharmacy__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pharmacy_Pharmacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_pharmacy_Pharmacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pharmacy_PharmacyPage__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pharmacy_PharmacyPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_pharmacy_PharmacyPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pharmacy_PharmacyEdit__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pharmacy_PharmacyEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_pharmacy_PharmacyEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pharmacy_PharmacyInfo__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pharmacy_PharmacyInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_pharmacy_PharmacyInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_pharmacy_rack_RackList__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_pharmacy_rack_RackList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_pharmacy_rack_RackList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_shelf_Shelf__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_shelf_Shelf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_shelf_Shelf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Pack__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Pack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Pack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pharmacy_rack_RackAdd__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pharmacy_rack_RackAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_pharmacy_rack_RackAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pharmacy_rack_RackEdit__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pharmacy_rack_RackEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_pharmacy_rack_RackEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_products_ProductEdit__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_products_ProductEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_products_ProductEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_reports_Versions__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_reports_Versions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_reports_Versions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_html_InputMaterial__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_html_InputMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_html_InputMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_html_SelectMaterial__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_html_SelectMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_html_SelectMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_pharmacy_RackOnPlan__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_pharmacy_RackOnPlan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_pharmacy_RackOnPlan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_html_CatEdit__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_html_CatEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_html_CatEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_EditableTD__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_EditableTD___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_EditableTD__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_html_DraggablePoint__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_html_DraggablePoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_html_DraggablePoint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_pharmacy_CopyRack__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_pharmacy_CopyRack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_pharmacy_CopyRack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_pharmacy_CopyShelf__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_pharmacy_CopyShelf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_pharmacy_CopyShelf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_pharmacy_LinkShelf__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_pharmacy_LinkShelf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_pharmacy_LinkShelf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_users_Users__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_users_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_users_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_users_UserAdd__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_users_UserAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_users_UserAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_reports_VersionAdd__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_reports_VersionAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_reports_VersionAdd__);

/* eslint-disable no-param-reassign */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













// import App from './App';













// import Reports from './components/Reports';














var bearerDriver = __webpack_require__(62);
var routerDriver = __webpack_require__(60);
var axiousDriver = __webpack_require__(59);

// const apolloClient = new ApolloClient({
//   networkInterface: createNetworkInterface({
//     uri: '/api/graphql/?',
//     transportBatching: true,
//     connectToDevTools: true,
//   }),
// });
// const apolloProvider = new VueApollo({
//   defaultClient: apolloClient,
// });


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);
// Vue.use(VueApollo, { apolloClient });
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_5_lodash___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Auth___default.a,
    meta: { auth: false, title: 'Авторизация' }
  }, { path: '/', redirect: '/pharmacies/' }, {
    path: '/pharmacies/',
    name: 'Pharmacies',
    component: __WEBPACK_IMPORTED_MODULE_14__components_pharmacy_Pharmacies___default.a,
    meta: { auth: true, title: 'Аптеки' },
    children: [
      // { path: 'new/', component: AddPharmacy },
    ]
  }, {
    path: '/products/',
    meta: { auth: true, title: 'Товары' },
    name: 'Products',
    component: __WEBPACK_IMPORTED_MODULE_13__components_products_Products___default.a,
    children: [
    // { path: 'categories/', component: Categories },
    { path: ':id', component: __WEBPACK_IMPORTED_MODULE_24__components_products_ProductEdit___default.a }]
  }, { path: '/racks/:rack/edit/', component: __WEBPACK_IMPORTED_MODULE_23__components_pharmacy_rack_RackEdit___default.a, name: 'editrack' }, {
    path: '/pharmacies/:id/',
    component: __WEBPACK_IMPORTED_MODULE_15__components_pharmacy_Pharmacy___default.a,
    meta: { auth: true },
    props: { title: true },
    children: [{ path: '/',
      redirect: 'info/',
      component: __WEBPACK_IMPORTED_MODULE_16__components_pharmacy_PharmacyPage___default.a,
      children: [{ path: 'edit/',
        component: __WEBPACK_IMPORTED_MODULE_17__components_pharmacy_PharmacyEdit___default.a,
        name: 'pharmedit',
        children: [{ path: 'copy/:rack/', component: __WEBPACK_IMPORTED_MODULE_32__components_pharmacy_CopyRack___default.a, name: 'copyrack' }]
      }, { path: 'info/', component: __WEBPACK_IMPORTED_MODULE_18__components_pharmacy_PharmacyInfo___default.a, name: 'pharminfo' }]
    }, { path: 'racks/',
      component: __WEBPACK_IMPORTED_MODULE_19__components_pharmacy_rack_RackList___default.a
    }, { path: 'racks/new/', component: __WEBPACK_IMPORTED_MODULE_22__components_pharmacy_rack_RackAdd___default.a }, { path: 'racks/:rack/',
      component: __WEBPACK_IMPORTED_MODULE_19__components_pharmacy_rack_RackList___default.a,
      children: [{ path: ':shelf/copy/', component: __WEBPACK_IMPORTED_MODULE_33__components_pharmacy_CopyShelf___default.a, name: 'copyshelf' }, { path: ':shelf/template/', component: __WEBPACK_IMPORTED_MODULE_34__components_pharmacy_LinkShelf___default.a, name: 'linkshelf' }]
    }, { path: 'racks/:rack/:shelf/',
      component: __WEBPACK_IMPORTED_MODULE_20__components_shelf_Shelf___default.a
    }]
  }, {
    path: '/reports/',
    name: 'Reports',
    component: __WEBPACK_IMPORTED_MODULE_25__components_reports_Versions___default.a,
    meta: { auth: true, title: 'Отчеты по аптекам' },
    children: [{ path: 'add/', component: __WEBPACK_IMPORTED_MODULE_37__components_reports_VersionAdd___default.a }]
  }, {
    path: '/users/',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_35__components_users_Users___default.a,
    meta: { auth: true, title: 'Сотрудники' },
    children: [{ path: ':user/', component: __WEBPACK_IMPORTED_MODULE_36__components_users_UserAdd___default.a }]
  }]
});

var store = new __WEBPACK_IMPORTED_MODULE_12_vuex__["a" /* default */].Store({
  state: {
    shelf: null,
    user: localStorage.user !== undefined ? JSON.parse(localStorage.user) : {}
  },
  mutations: {
    shelf: function shelf(state, _shelf) {
      state.shelf = _shelf;
    },
    user: function user(state, _user) {
      state.user = _user;
    }
  },
  getters: {
    rackShelfInfo: function rackShelfInfo(state) {
      return state.shelf !== null ? state.shelf.rack.title + ' / #' + state.shelf.number : '';
    }
  },
  actions: {
    auth: function auth(_ref, user) {
      var commit = _ref.commit,
          state = _ref.state;

      localStorage.user = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user);
      commit('user', user);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__websanova_vue_auth___default.a, {
  auth: bearerDriver,
  http: axiousDriver,
  router: routerDriver,
  refreshData: {
    enabled: false // true by default.
  },
  loginData: { url: 'api/token/auth/', method: 'POST', redirect: '/', fetchUser: true },
  fetchData: { url: 'api/token/verify/', method: 'POST', enabled: true, data: { token: '' } }

});
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('flat-pickr', __WEBPACK_IMPORTED_MODULE_9_vue_flatpickr_component___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('pack', __WEBPACK_IMPORTED_MODULE_21__components_Pack___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('materialInput', __WEBPACK_IMPORTED_MODULE_26__components_html_InputMaterial___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('materialSelect', __WEBPACK_IMPORTED_MODULE_27__components_html_SelectMaterial___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('rackOnPlan', __WEBPACK_IMPORTED_MODULE_28__components_pharmacy_RackOnPlan___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('editable-cat', __WEBPACK_IMPORTED_MODULE_29__components_html_CatEdit___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('editable-td', __WEBPACK_IMPORTED_MODULE_30__components_EditableTD___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('draggable', __WEBPACK_IMPORTED_MODULE_10_vuedraggable___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('draggable-point', __WEBPACK_IMPORTED_MODULE_31__components_html_DraggablePoint___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  data: {
    user: {}
  },
  store: store,
  router: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].router,
  template: '<App/>',
  // eslint-disable-next-line global-require
  components: { App: __webpack_require__(67) }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      pageTitle: 'Аптеки'
    };
  },

  computed: {
    user: function user() {
      return this.$store.state.user;
    }
  },
  watch: {
    $route: function $route(to) {
      this.pageTitle = to.meta.title;
    }
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__html_InputMaterial__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__html_InputMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__html_InputMaterial__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios';


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'auth',
  data: function data() {
    return {
      pageTitle: 'Planogram',
      msg: 'Необходима авторизация',
      email: '',
      password: '',
      bodyClassName: 'body'
    };
  },


  methods: {
    logMe: function logMe() {
      this.$auth.login({
        data: {
          email: this.email,
          password: this.password
        },
        success: function success(data) {
          var _this = this;

          this.$store.dispatch('auth', data.data.user).then(function () {
            _this.$router.push('/pharmacies/');
          });
        },
        error: function error() {},

        rememberMe: true,
        fetchUser: false
      });
    }
  },
  mounted: function mounted() {
    document.body.classList.add(this.bodyClassName);
    document.getElementById('header').classList.add('hide');
  },
  destroyed: function destroyed() {
    document.body.classList.remove(this.bodyClassName);
    document.getElementById('header').classList.remove('hide');
  },


  components: { inputMaterial: __WEBPACK_IMPORTED_MODULE_0__html_InputMaterial___default.a }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'drop-zone',
  props: {
    id: {
      type: Number,
      required: true
    },
    productId: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    initImage: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    fileDropped: function fileDropped(event) {
      var _this = this;

      this.dropStyle.background = 'white';
      var file = event.dataTransfer.files[0];

      var data = new FormData();
      data.append('product', this.productId);
      data.append('photo', file);
      data.append('side', this.type);

      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/productphoto/', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function onUploadProgress(progressEvent) {
          var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
          if (percentCompleted === 100) {
            var reader = new FileReader();
            // Closure to capture the file information.
            reader.onload = function (theFile) {
              self.imageSrc = theFile.target.result;
              self.showImage = true;
            };
            reader.readAsDataURL(file);
          } else {
            self.loadPercent = percentCompleted + '%';
          }
        }
      }).then(function (response) {
        response.image = _this.imageSrc;
        self.$emit('uploaded', response);
      });
    },
    fileOver: function fileOver() {
      this.dropStyle.background = '#ccc';
    },
    fileLeave: function fileLeave() {
      this.dropStyle.background = '';
    },
    delete: function _delete() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/api/productphoto/', { id: this.id }).then(function () {
        _this2.imageStyle.backgroundImage = '';
        _this2.showImage = false;
      });
    }
  },
  watch: {
    initImage: function initImage() {
      if (this.initImage) {
        this.imageSrc = this.initImage;
      }
    },
    imageSrc: function imageSrc() {
      this.imageStyle.backgroundImage = 'url(' + this.imageSrc + ')';
      this.showImage = true;
      this.dropStyle.backgroundColor = 'white';
    }
  },
  data: function data() {
    return {
      dropStyle: { background: '' },
      imageStyle: { backgroundImage: '', backgroundSize: 'contain' },
      imageSrc: this.initImage,
      showImage: false,
      loadPercent: '+'
    };
  }
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editable-td',
  props: {
    initValue: {
      type: [Number, String],
      required: false
    }
  },
  data: function data() {
    return {
      editValue: this.initValue,
      isEditMode: false
    };
  },

  watch: {
    initValue: function initValue(val) {
      this.editValue = val;
    }
  },
  methods: {
    onDoubleClick: function onDoubleClick() {
      this.isEditMode = true;
    },
    onSubmit: function onSubmit() {
      this.isEditMode = false;
      this.$emit('input', this.editValue);
    }
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pack',
  props: {
    initPos: {
      type: Number,
      required: false
    },
    initWidth: {
      type: Number,
      required: true
    },
    initHeight: {
      type: Number,
      required: true
    },
    initDepth: {
      type: Number,
      required: true
    },
    isMirrored: {
      type: Boolean,
      default: false
    },
    initFrontImg: {
      type: String,
      required: true
    },
    initTopImg: {
      type: String,
      required: true
    },
    initRightImg: {
      type: String,
      required: true
    },
    initLeftImg: {
      type: String,
      required: true
    },
    initBottomImg: {
      type: String,
      required: true
    },
    initBackImg: {
      type: String,
      required: true
    },
    isDraggable: {
      type: Boolean,
      default: false
    },
    x: { // x
      type: Number,
      required: false,
      default: 0
    },
    y: { // y
      type: Number,
      required: false,
      default: 0
    },
    z: { // z
      type: Number,
      required: false,
      default: 0
    },
    zIndex: {
      type: Number,
      required: false,
      default: 1
    },
    id: {
      type: Number,
      required: false,
      default: 0
    },
    selected: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      required: false,
      default: 1
    },
    screenshot: {
      type: Boolean,
      default: false
    },
    dominantColor: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    holderClass: function holderClass() {
      return this.selected ? '--selected' : '';
    },
    width: function width() {
      return this.initWidth * this.zoom;
    },
    height: function height() {
      return this.pos === 0 ? this.initHeight * this.zoom : this.initDepth * this.zoom;
    },
    depth: function depth() {
      return this.pos === 0 ? this.initDepth * this.zoom : this.initHeight * this.zoom;
    },
    topImg: function topImg() {
      return this.pos === 0 ? this.initTopImg : this.initFrontImg;
    },
    frontImg: function frontImg() {
      return this.pos === 0 ? this.initFrontImg : this.initBottomImg;
    },
    backImg: function backImg() {
      return this.pos === 0 ? this.initBackImg : this.initTopImg;
    },
    bottomImg: function bottomImg() {
      return this.pos === 0 ? this.initBottomImg : this.initBackImg;
    },
    rightImg: function rightImg() {
      return this.initRightImg;
    },
    front: function front() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        backgroundColor: this.dominantColor,
        backgroundSize: this.width + 'px ' + this.height + 'px',
        backgroundImage: 'url("' + this.frontImg + '")',
        transform: 'translate3d(0, 0, 0)'
      };
    },
    back: function back() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        backgroundColor: this.dominantColor,
        backgroundSize: this.width + 'px ' + this.height + 'px',
        backgroundImage: 'url("' + this.backImg + '")',
        transform: 'translate3d(100%, 0, -' + this.depth + 'px) rotate3d(0, -1, 0, 180deg)',
        display: this.screenshot ? 'none' : ''
      };
    },
    left: function left() {
      return {
        width: this.height + 'px',
        height: this.depth + 'px',
        backgroundColor: this.dominantColor,
        backgroundSize: this.height + 'px ' + this.depth + 'px',
        backgroundImage: 'url("' + this.initLeftImg + '")',
        transform: 'translate3d(0, 0, -' + this.depth + 'px) rotateY(-90deg) rotateZ(-90deg)'
      };
    },
    bottom: function bottom() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px',
        backgroundColor: this.dominantColor,
        backgroundSize: this.width + 'px ' + this.depth + 'px',
        backgroundImage: 'url("' + this.bottomImg + '")',
        transform: 'translate3d(0, 0, 0) rotate3d(1, 0, 0, -90deg)'
      };
    },
    right: function right() {
      return {
        width: this.depth + 'px',
        height: this.height + 'px',
        backgroundColor: this.dominantColor,
        backgroundSize: this.depth + 'px ' + this.height + 'px',
        backgroundImage: 'url("' + this.initRightImg + '")',
        transform: 'translate3d(0, 0, 0) rotateY(90deg)'
      };
    },
    top: function top() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px',
        backgroundColor: this.dominantColor,
        backgroundSize: this.width + 'px ' + this.depth + 'px',
        backgroundImage: 'url("' + this.topImg + '")',
        transform: 'translate3d(0, 0, 0px) rotate3d(1, 0, 0, 90deg)'
      };
    },
    holder: function holder() {
      return {
        height: this.height,
        width: this.width,
        depth: this.depth
      };
    },
    holderWithPx: function holderWithPx() {
      return {
        height: this.holder.height + 'px',
        width: this.holder.width + 'px',
        transform: 'translate3d(' + this.x + 'px, ' + this.y + 'px,' + this.z + 'px)'
      };
    }
  },
  watch: {
    holder: function holder() {
      var size = {};
      size.width = this.holder.width;
      size.height = this.holder.height;
      size.depth = this.holder.depth;
      size.frontWidth = this.width;
      this.$emit('sizeCalcutated', { size: size, id: this.id });
    },
    initPos: function initPos() {
      this.pos = this.initPos;
    }
  },
  methods: {
    dblClick: function dblClick() {
      this.$emit('removePack', this.id);
    },
    click: function click(e, side) {
      if (e.shiftKey && !e.altKey) {
        this.$emit('moveToSide', {
          id: this.id,
          event: e,
          offsetX: e.clientX - this.$el.offsetLeft,
          offsetY: e.clientY - this.$el.offsetTop,
          x: this.x,
          y: this.y,
          side: side
        });
      } else if (e.altKey && !e.shiftKey) {
        this.$emit('select', {
          id: this.id,
          event: e,
          offsetX: e.clientX - this.$el.offsetLeft,
          offsetY: e.clientY - this.$el.offsetTop,
          x: this.x,
          y: this.y,
          side: side
        });
      } else if (e.altKey && e.shiftKey) {
        this.$emit('rotate', this.id);
      } else {
        this.$emit('click', this.id);
      }
    },
    mousedown: function mousedown(e, side) {
      if (!e.metaKey) {
        this.$emit('mousedown', {
          id: this.id,
          event: e,
          offsetX: e.clientX - this.x,
          offsetY: e.clientY - this.y,
          offsetZ: e.clientY - this.z,
          side: side,
          x: this.x,
          y: this.y,
          z: this.z
        });
      }
    }
  },
  data: function data() {
    return {
      pos: this.initPos
    };
  },
  created: function created() {
    var size = {};
    size.width = this.holder.width;
    size.height = this.holder.height;
    size.frontWidth = this.width;
    size.depth = this.holder.depth;
    this.$emit('sizeCalcutated', { size: size, id: this.id });
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editable-cat',
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true,
      default: ''
    },
    initDate: {
      type: String,
      required: false,
      default: '27.12.2017'
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cssClass: function cssClass() {
      return this.selected ? 'category--selected' : '';
    }
  },
  methods: {
    titleChanged: function titleChanged(input) {
      this.$emit('titleChanged', { id: this.id, title: input });
    }
  },
  data: function data() {
    return {
      date: this.initDate,
      config: {
        altFormat: 'd.m.Y',
        altInput: true,
        dateFormat: 'd.m.Y'
      }
    };
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var TYPE_MIDDLE = 1;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'draggable-point',
  template: '<div\n@mousedown="mousedown"\n@dblclick="dblclick"\n:style="style"\nclass="wall-point"\n></div>',
  props: {
    top: Number,
    left: Number,
    type: Number,
    insertPos: Number,
    lineIndex: Number,
    id: [String, Number]
  },
  methods: {
    dblclick: function dblclick(e) {
      this.$emit('remove', {
        id: this.id,
        type: this.type,
        insertPos: this.insertPos || null,
        event: e,
        offsetX: e.clientX - this.$el.offsetLeft,
        offsetY: e.clientY - this.$el.offsetTop,
        x: this.left,
        y: this.top,
        lineIndex: this.lineIndex
      });
    },
    mousedown: function mousedown(e) {
      this.$emit('mousedown', {
        id: this.id,
        type: this.type,
        insertPos: this.insertPos || null,
        event: e,
        offsetX: e.clientX - this.$el.offsetLeft,
        offsetY: e.clientY - this.$el.offsetTop,
        x: this.left,
        y: this.top
      });
    }
  },
  computed: {
    style: function style() {
      return {
        background: '' + (this.type === TYPE_MIDDLE ? '#F4F5F6' : '#88929D'),
        position: 'absolute',
        top: this.top + 'px',
        left: this.left + 'px'
      };
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'material-input',
  props: {
    parentClass: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    valueStr: {
      type: String,
      default: ''
    },
    valueNumber: {
      type: Number
    },
    value: Number
  },
  methods: {
    focus: function focus() {
      this.isFocused = true;
    },
    blur: function blur() {
      this.isFocused = false;
    }
  },
  watch: {
    valueMutatedStr: function valueMutatedStr(input) {
      this.$emit('inputStr', input);
    },
    valueMutatedNumber: function valueMutatedNumber(input) {
      this.$emit('inputNumber', Number(input));
    },
    valueNumber: function valueNumber(input) {
      this.valueMutatedNumber = input;
    }
  },
  computed: {
    labelClass: function labelClass() {
      if (this.valueMutatedStr.length > 0 || this.valueMutatedNumber > 0 || this.isFocused) {
        return 'active';
      }
      return '';
    }
  },
  data: function data() {
    return {
      valueMutatedStr: this.valueStr,
      valueMutatedNumber: this.valueNumber,
      isFocused: false,
      id: Math.random()
    };
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'material-select',
  props: {
    isMulti: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Выберите...'
    },
    possibleValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selectedValues: {
      type: [Array, String],
      default: function _default() {
        return [];
      },

      required: false
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    allowSearch: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeSearchBox: function closeSearchBox() {
      this.isOpen = false;
    }
  },
  watch: {
    selectedValues: function selectedValues(input) {
      this.checkedVariants = input;
    },
    checkedVariants: function checkedVariants(input) {
      if (!this.isMulti) {
        this.isOpen = false;
      }
      this.$emit('select', input);
    },
    possibleValues: function possibleValues() {
      this.checkedVariants = this.selectedValues;
    }
  },
  computed: {
    showTitle: function showTitle() {
      var _this = this;

      if (!this.isMulti && this.checkedVariants.length > 0) {
        if (this.possibleValues.filter(function (val) {
          return val.id === _this.checkedVariants;
        })[0] !== undefined) {
          return this.possibleValues.filter(function (val) {
            return val.id === _this.checkedVariants;
          })[0].title;
        }
      }
      return this.title;
    },
    possibleValuesMapped: function possibleValuesMapped() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.possibleValues.map(function (o) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, o.id, o.title);
      })));
    },
    possibleValuesFiltered: function possibleValuesFiltered() {
      var _this2 = this;

      return this.possibleValues.filter(function (value) {
        return _this2.searchString === '' || value.title.toUpperCase().includes(_this2.searchString.toUpperCase());
      });
    }
  },
  data: function data() {
    return {
      id: Math.random(),
      isOpen: false,
      checkedVariants: this.selectedValues,
      searchString: ''
    };
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rack-add',
  created: function created() {
    this.loadPharmacies();
  },

  methods: {
    loadPharmacies: function loadPharmacies() {
      var _this = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/pharmacies/').then(function (response) {
        that.isLoading = false;
        _this.pharmacies = response.data;
      });
    },
    copy: function copy() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/copyRack/', {
        rackId: this.$route.params.rack,
        toId: this.pharmacy,
        angle: 0,
        startX: 0,
        startY: 0
      }).then(function () {
        that.$router.push('../../');
      });
    }
  },
  data: function data() {
    return {
      pharmacy: '',
      pharmacies: []
    };
  },

  components: { selectMaterial: __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial___default.a }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__html_SelectMaterial__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__html_SelectMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__html_SelectMaterial__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rack-add',
  created: function created() {
    this.loadPharmacies();
  },

  watch: {
    pharmacy: function pharmacy() {
      this.loadRacks();
    },
    rack: function rack() {
      this.loadShelfs();
    }
  },
  methods: {
    loadPharmacies: function loadPharmacies() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/v2/pharmacies/').then(function (response) {
        that.pharmaciesList = response.data;
      });
    },
    loadRacks: function loadRacks() {
      var that = this;
      that.rackList = [];
      that.shelfList = [];
      if (that.pharmacy !== '') {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/v2/racks/?pharmacy=' + that.pharmacy).then(function (response) {
          that.rackList = response.data;
        });
      }
    },
    loadShelfs: function loadShelfs() {
      var that = this;
      that.shelfList = [];
      if (that.rack !== '') {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/v2/shelfs/?rack=' + that.rack).then(function (response) {
          that.shelfList = response.data.results.map(function (shelf, index) {
            var t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(shelf);
            t.title = response.data.results.length - index;
            return t;
          });
        });
      }
    },
    copy: function copy() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/api/copyShelf/', {
        toId: this.shelf,
        fromId: this.$route.params.shelf
      }).then(function () {
        _this.$router.push('../../');
      });
    }
  },
  data: function data() {
    return {
      pharmacy: '',
      pharmaciesList: [],
      rack: '',
      rackList: [],
      shelf: '',
      shelfList: []

    };
  },

  components: { selectMaterial: __WEBPACK_IMPORTED_MODULE_2__html_SelectMaterial___default.a }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__html_SelectMaterial__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__html_SelectMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__html_SelectMaterial__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rack-add',
  created: function created() {
    this.loadPharmacies();
  },

  watch: {
    pharmacy: function pharmacy() {
      this.loadRacks();
    },
    rack: function rack() {
      this.loadShelfs();
    }
  },
  methods: {
    loadPharmacies: function loadPharmacies() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/v2/pharmacies/?is_template=true').then(function (response) {
        that.pharmaciesList = response.data;
      });
    },
    loadRacks: function loadRacks() {
      var that = this;
      that.rackList = [];
      that.shelfList = [];
      if (that.pharmacy !== '') {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/v2/racks/?pharmacy=' + that.pharmacy).then(function (response) {
          that.rackList = response.data;
        });
      }
    },
    loadShelfs: function loadShelfs() {
      var that = this;
      that.shelfList = [];
      if (that.rack !== '') {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/api/v2/shelfs/?rack=' + that.rack).then(function (response) {
          that.shelfList = response.data.results.map(function (shelf, index) {
            var t = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(shelf);
            t.title = response.data.results.length - index;
            return t;
          });
        });
      }
    },
    link: function link() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch('/api/v2/shelfs/' + this.$route.params.shelf + '/', {
        template_shelf: this.shelf
      }).then(function () {
        _this.$router.push('../../');
      });
    }
  },
  data: function data() {
    return {
      pharmacy: '',
      pharmaciesList: [],
      rack: '',
      rackList: [],
      shelf: '',
      shelfList: []

    };
  },

  components: { selectMaterial: __WEBPACK_IMPORTED_MODULE_2__html_SelectMaterial___default.a }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import axios from 'axios';





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_2_lodash___default.a);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pharmacies',
  data: function data() {
    return {
      pharmaciesList: [],
      search: ''
    };
  },
  created: function created() {
    this.load('');
  },

  watch: {
    search: function search(val) {
      this.load(val);
    }
  },
  methods: {
    inputStr: __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]._.debounce(function mutated(input) {
      this.search = input;
    }, 500),
    load: function load(str) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/api/v2/pharmacies/?search=' + str).then(function (response) {
        // console.log(response.data);
        that.makeList(response.data);
      });
    },
    makeList: function makeList(response) {
      var _this = this;

      this.pharmaciesList = [];

      if (response.length > 0) {
        response.forEach(function (pharmacy) {
          var pharmacyO = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, pharmacy);

          var maxX = 0;
          var maxY = 0;
          // console.log(pharmacy.contour);
          // const contour = JSON.parse(pharmacy.contour);
          // console.log(contour);
          if (pharmacy.contour !== null) {
            var points = pharmacy.contour.map(function (stat, i) {
              if (stat.x > maxX) {
                maxX = stat.x;
              }
              if (stat.y > maxY) {
                maxY = stat.y;
              }
              return (i > 0 ? 'L' : '') + ' ' + stat.x + ',' + stat.y;
            }).join(' ');
            pharmacyO.contour = 'M ' + points + ' Z';

            pharmacyO.maxX = maxX;
            pharmacyO.maxY = maxY;
            pharmacyO.viewbox = '0, 0, ' + maxX + ', ' + maxY;
          }

          // let walls = JSON.parse(pharmacy.walls);
          if (pharmacy.walls !== null) {
            // eslint-disable-next-line no-const-assign
            var walls = pharmacy.walls.map(function (line) {
              // eslint-disable-next-line no-param-reassign,arrow-body-style
              line.str = line.map(function (point, i) {
                return (i > 0 ? 'L' : '') + ' ' + point.x + ',' + point.y;
              }).join(' ');
              // eslint-disable-next-line no-param-reassign
              line.str = 'M ' + line.str;
              return line;
            });

            pharmacyO.partitions = walls;
          }
          _this.pharmaciesList.push(pharmacyO);
        });
      }
    }
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pharmacy',
  created: function created() {
    this.loadPharmacyInfo();
  },
  data: function data() {
    return {
      pharmacy: { categories: [] },
      statuses: {
        NEW: 'Новая',
        SEEN: 'В работе',
        DONE: 'Сделано'
      }
    };
  },

  methods: {
    loadPharmacyInfo: function loadPharmacyInfo() {
      var _this = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/pharmacies/' + this.$route.params.id + '/').then(function (response) {
        that.isLoading = false;
        _this.pharmacy = response.data;
      });
    },
    changeVersionStatus: function changeVersionStatus(status) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/v2/versions/' + that.pharmacy.version.id + '/', { status: status }).then(function (response) {
        that.isLoading = false;
        that.pharmacy.version.status = status;
        console.log(response);
      });
    },
    print: function print() {
      window.print();
    },
    save: function save() {
      this.$emit('save');
    }
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-unused-vars,no-plusplus,arrow-body-style,
 no-empty,no-mixed-operators,no-nested-ternary, no-param-reassign,
 no-trailing-spaces, padded-blocks  */



var TYPE_DEF = 0;
var TYPE_MIDDLE = 1;
var TYPE_WALL = 2;
var TYPE_RACK = 3;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pharmacy-edit',
  data: function data() {
    return {
      title: '',
      rackSort: 100,
      isExt: false,
      angleValue: 0,
      angleVisible: false,
      initContourPoints: [{ y: 40, x: 40, type: TYPE_DEF }, { y: 40, x: 640, type: TYPE_DEF }, { y: 400, x: 640, type: TYPE_DEF }, { y: 400, x: 40, type: TYPE_DEF }],
      guides: [],
      initPartitions: [[{ x: 501, y: 67, type: TYPE_WALL }, { x: 433, y: 241, type: TYPE_WALL }]],
      whatToMove: null,
      whatToRotate: null,
      rackprototypesTransformed: [],
      initRacks: [],
      rackTitle: '',
      saving: false
    };
  },
  created: function created() {
    var self = this;
    self.loadPharmacyInfo();
    self.loadPrototypes();
    this.$parent.$parent.$on('save', function () {
      self.save();
    });
  },
  destroyed: function destroyed() {
    this.$parent.$parent.$off('save');
  },

  methods: {
    loadPrototypes: function loadPrototypes() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('/api/v2/prototypes/').then(function (response) {
        self.isLoading = false;
        self.makePrototypesList(response.data);
      });
    },
    loadPharmacyInfo: function loadPharmacyInfo() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('/api/v2/pharmacies/' + this.$route.params.id + '/').then(function (response) {
        self.isLoading = false;
        self.makePlan(response.data);
      });
    },
    makePlan: function makePlan(response) {
      if (response.contour !== null) {
        this.initContourPoints = response.contour;
      }
      if (response.walls !== null) {
        this.initPartitions = response.walls;
      }

      if (response.racks.length > 0) {
        this.initRacks = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(response.racks.map(function (o) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, o.id, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, o));
        })));
      } else {
        this.initRacks = {};
      }
    },
    makePrototypesList: function makePrototypesList(response) {
      this.rackprototypesTransformed = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(response.map(function (o) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, o.id, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, o));
      })));
    },
    planHolderClick: function planHolderClick() {
      this.angleVisible = false;
    },
    copyRackWithItems: function copyRackWithItems() {
      var _this = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('/api/copyRack/', {
        rackId: this.whatToRotate.id,
        toId: this.$route.params.id,
        angle: this.whatToRotate.angle,
        startX: 0,
        startY: 0
      }).then(function (answer) {
        that.$set(_this.initRacks, answer.data.id, {
          id: answer.data.id,
          startX: 0,
          startY: 0,
          angle: 0,
          title: _this.whatToRotate.title,
          // eslint-disable-next-line max-len
          rackPrototype: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(that.racks).filter(function (rack) {
            return rack.id === that.whatToRotate.id;
          })[0].rackPrototype
        });
      });
    },
    copyRackWithItemsToOtherPharmacy: function copyRackWithItemsToOtherPharmacy() {
      this.$router.push('/pharmacies/' + this.$route.params.id + '/edit/copy/' + this.whatToRotate.id + '/');
    },
    addRack: function addRack(rack) {

      var newId = 'newID' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.initRacks).length;
      this.$set(this.initRacks, newId, {
        id: newId,
        startX: 0,
        startY: 0,
        angle: 0,
        newly: true,
        title: rack.title,
        prototype: rack
      });
    },
    removeRack: function removeRack(rack) {
      this.$delete(this.initRacks, rack);
    },
    remove: function remove(e) {
      if (e.type === TYPE_DEF) {
        this.initContourPoints.splice(e.id, 1);
      } else if (e.type === TYPE_WALL) {
        this.initPartitions.splice(e.lineIndex, 1);
      }
    },
    mousedown: function mousedown(e) {
      if (e.type === TYPE_MIDDLE) {
        this.initContourPoints.splice(e.insertPos, 0, { x: e.x, y: e.y, type: TYPE_DEF });
        e.id = e.insertPos;
      }
      this.whatToMove = e;
    },
    contextmenu: function contextmenu(e) {
      this.whatToRotate = e;
      this.angleValue = e.angle;
      this.angleVisible = true;
      this.rackTitle = e.title;
      this.isExt = e.isExt ? e.isExt : false;
      this.rackSort = e.sort;
    },
    mousemove: function mousemove(e) {
      var _this2 = this;

      if (this.whatToMove !== null) {
        if (this.whatToMove.type === TYPE_RACK) {

          this.$set(this.initRacks[this.whatToMove.id], 'startX', e.clientX - this.whatToMove.offsetX);
          this.$set(this.initRacks[this.whatToMove.id], 'startY', e.clientY - this.whatToMove.offsetY);

          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.initRacks).forEach(function (element) {
            if (element.id !== _this2.whatToMove.id) {
              if (!e.shiftKey) {

                if (Math.abs(_this2.initRacks[_this2.whatToMove.id].startY - element.startY) < 10) {
                  _this2.$set(_this2.initRacks[_this2.whatToMove.id], 'startY', element.startY);
                }

                if (Math.abs(_this2.initRacks[_this2.whatToMove.id].startX - element.startX) < 10) {
                  _this2.$set(_this2.initRacks[_this2.whatToMove.id], 'startX', element.startX);
                }
              }
            }
          });
        } else if (this.whatToMove.type !== TYPE_WALL) {
          this.initContourPoints[this.whatToMove.id].y = e.clientY - this.whatToMove.offsetY;
          this.initContourPoints[this.whatToMove.id].x = e.clientX - this.whatToMove.offsetX;

          this.guides = [];
          this.initContourPoints.forEach(function (element) {
            if (element.id !== _this2.whatToMove.id) {
              // snapping
              if (!e.shiftKey) {
                if (Math.abs(_this2.initContourPoints[_this2.whatToMove.id].y - element.y) < 10) {
                  _this2.initContourPoints[_this2.whatToMove.id].y = element.y;
                }

                if (Math.abs(_this2.initContourPoints[_this2.whatToMove.id].x - element.x) < 10) {
                  _this2.initContourPoints[_this2.whatToMove.id].x = element.x;
                }
              }

              // lines
              if (element.x === _this2.initContourPoints[_this2.whatToMove.id].x) {
                _this2.guides.push({
                  x1: element.x,
                  y1: element.y,
                  x2: element.x,
                  y2: _this2.initContourPoints[_this2.whatToMove.id].y
                });
              }
              if (element.y === _this2.initContourPoints[_this2.whatToMove.id].y) {
                _this2.guides.push({
                  x1: element.x,
                  y1: element.y,
                  x2: _this2.initContourPoints[_this2.whatToMove.id].x,
                  y2: element.y
                });
              }
            }
          });
        } else {
          var pointId = this.whatToMove.id % 1000;
          var lineId = (this.whatToMove.id - pointId) / 1000;

          this.initPartitions[lineId][pointId].y = e.clientY - this.whatToMove.offsetY;
          this.initPartitions[lineId][pointId].x = e.clientX - this.whatToMove.offsetX;

          this.guides = [];

          this.initPartitions[lineId].forEach(function (element) {
            if (element.id !== _this2.whatToMove.id) {
              if (!e.shiftKey) {
                if (Math.abs(_this2.initPartitions[lineId][pointId].y - element.y) < 10) {
                  _this2.initPartitions[lineId][pointId].y = element.y;
                }

                if (Math.abs(_this2.initPartitions[lineId][pointId].x - element.x) < 10) {
                  _this2.initPartitions[lineId][pointId].x = element.x;
                }
              }

              if (element.x === _this2.initPartitions[lineId][pointId].x) {
                _this2.guides.push({
                  x1: element.x,
                  y1: element.y,
                  x2: element.x,
                  y2: _this2.initPartitions[lineId][pointId].y
                });
              }
              if (element.y === _this2.initPartitions[lineId][pointId].y) {
                _this2.guides.push({
                  x1: element.x,
                  y1: element.y,
                  x2: _this2.initPartitions[lineId][pointId].x,
                  y2: element.y
                });
              }
            }
          });

          this.initContourPoints.forEach(function (element) {
            if (!e.shiftKey) {
              if (Math.abs(_this2.initPartitions[lineId][pointId].y - element.y) < 10) {
                _this2.initPartitions[lineId][pointId].y = element.y;
              }

              if (Math.abs(_this2.initPartitions[lineId][pointId].x - element.x) < 10) {
                _this2.initPartitions[lineId][pointId].x = element.x;
              }
            }
            // lines
            if (element.x === _this2.initPartitions[lineId][pointId].x) {
              _this2.guides.push({
                x1: element.x,
                y1: element.y,
                x2: element.x,
                y2: _this2.initPartitions[lineId][pointId].y
              });
            }
            if (element.y === _this2.initPartitions[lineId][pointId].y) {
              _this2.guides.push({
                x1: element.x,
                y1: element.y,
                x2: _this2.initPartitions[lineId][pointId].x,
                y2: element.y
              });
            }
          });
        }
      }
    },
    mouseup: function mouseup(e) {
      this.guides = [];
      this.whatToMove = null;
    },
    addPartition: function addPartition() {
      this.initPartitions.push([{ x: 501, y: 67, type: TYPE_WALL }, { x: 433, y: 241, type: TYPE_WALL }]);
    },
    save: function save() {
      var _this3 = this;

      this.saving = true;
      var racks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.initRacks).map(function (element) {
        if (element.newly !== undefined && element.newly) {
          delete element.id;
        }
        element.rackPrototype = element.prototype.id;
        element.prototype = null;
        return element;
      });

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.patch('/api/pharmacy/' + this.$route.params.id, {
        walls: this.initPartitions,
        contour: this.initContourPoints,
        racks: racks
      }).then(function () {
        _this3.saving = false;
        window.location.reload();
      });
    }
  },
  computed: {
    /* eslint no-param-reassign: ["error",
     { "props": true, "ignorePropertyModificationsFor": ["point"] }] */
    draggablePoints: function draggablePoints() {
      var _this4 = this;

      var transformed = [];
      this.initContourPoints.forEach(function (point, index) {
        point.id = index;
        transformed.push(point);
        var nextPoint = { type: TYPE_MIDDLE, insertPos: index + 1 };
        if (index < _this4.initContourPoints.length - 1) {
          nextPoint.x = point.x + (_this4.initContourPoints[index + 1].x - point.x) / 2;
          nextPoint.y = point.y + (_this4.initContourPoints[index + 1].y - point.y) / 2;
        } else {
          nextPoint.x = point.x + (_this4.initContourPoints[0].x - point.x) / 2;
          nextPoint.y = point.y + (_this4.initContourPoints[0].y - point.y) / 2;
        }
        transformed.push(nextPoint);
      });

      this.initPartitions.forEach(function (line, index) {
        line.forEach(function (point, pointIndex) {
          point.id = index * 1000 + pointIndex;
          point.lineIndex = index;
          transformed.push(point);
        });
      });
      return transformed;
    },
    contour: function contour() {
      var points = this.initContourPoints.map(function (stat, i) {
        return (i > 0 ? 'L' : '') + ' ' + stat.x + ',' + stat.y;
      }).join(' ');
      return 'M ' + points + ' Z';
    },
    partitions: function partitions() {
      return this.initPartitions.map(function (line) {
        line.str = line.map(function (point, i) {
          return (i > 0 ? 'L' : '') + ' ' + point.x + ',' + point.y;
        }).join(' ');
        line.str = 'M ' + line.str;
        return line;
      });
    },
    racks: function racks() {
      return this.initRacks;
    },
    angleBlock: function angleBlock() {
      return {
        top: (this.whatToRotate ? this.whatToRotate.y : 0) + 'px',
        left: (this.whatToRotate ? this.whatToRotate.x : 0) + 'px',
        position: 'absolute'
      };
    }
  },
  watch: {
    angleValue: function angleValue(input) {
      this.$set(this.initRacks[this.whatToRotate.id], 'angle', input);
    },
    rackTitle: function rackTitle(input) {
      this.$set(this.initRacks[this.whatToRotate.id], 'title', input);
    },
    isExt: function isExt(input) {
      this.$set(this.initRacks[this.whatToRotate.id], 'isExt', input);
    },
    rackSort: function rackSort(input) {
      this.$set(this.initRacks[this.whatToRotate.id], 'sort', input);
    }
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-unused-vars,no-plusplus,arrow-body-style,
 no-empty,no-mixed-operators,no-nested-ternary, no-param-reassign,
 no-trailing-spaces, padded-blocks  */


var TYPE_DEF = 0;
var TYPE_MIDDLE = 1;
var TYPE_WALL = 2;
var TYPE_RACK = 3;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pharmacy-info',
  // apollo: {
  //   products: {
  //     query: gql`
  //         query($endCursor: String, $onlyRemove: Boolean, $onlyAdd: Boolean,
  //         $pharmacy: String, $rack: String, $onlyNeedPlacement: Boolean,
  //         $onlyNeedRemoval: Boolean,
  //         $userId: String
  //         ){
  //         products(first:50, pharmacy: $pharmacy,
  //         rack: $rack,
  //         onlyRemove: $onlyRemove,
  //         showNeedPlacement: $onlyNeedPlacement,
  //         needRemoval: $onlyNeedRemoval,
  //         userId: $userId,
  //         onlyAdd: $onlyAdd, after: $endCursor) {
  //           pageInfo {
  //             hasNextPage
  //             hasPreviousPage
  //             startCursor
  //             endCursor
  //           }
  //           edges {
  //             node {
  //               id,
  //               title,
  //               notInOrder,
  //               cluster{id,title},
  //               groupId,
  //               noFacing
  //               photos {
  //                 edges {
  //                   node {
  //                     photo
  //                   }
  //                 }
  //               },
  //               facinginfo(pharmacy: $pharmacy) {
  //                 facingCount
  //                 facingPlan
  //                 prevCount
  //                 actualCount
  //                 chancheType
  //               }
  //
  //             }
  //       }
  //     }}`,
  //     variables() {
  //       return {
  //         searchStr: this.searchStr,
  //         endCursor: '',
  //         onlyRemove: this.onlyRemove,
  //         onlyAdd: this.onlyAdd,
  //         onlyNeedPlacement: this.onlyNeedPlacement,
  //         pharmacy: this.$route.params.id,
  //         rack: this.rack,
  //         onlyNeedRemoval: this.onlyNeedRemoval,
  //         userId: this.$parent.$parent.$parent.user.id,
  //       };
  //     },
  //     fetchPolicy: 'cache-and-network',
  //   },
  // },
  data: function data() {
    return {
      title: '',
      angleValue: 0,
      angleVisible: false,
      initContourPoints: [],
      guides: [],
      initPartitions: [],
      initRacks: [],
      products: [],
      categories: [],
      currentPage: '/api/products/',
      isLoading: false,
      hasNext: true,
      rack: '',
      selectedRackName: '',
      currentRack: null
    };
  },
  created: function created() {
    var self = this;
    this.$parent.$on('save', function () {
      self.save();
    });
    this.loadPharmacyInfo();
  },

  methods: {
    loadPharmacyInfo: function loadPharmacyInfo() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/v2/pharmacies/' + this.$route.params.id + '/').then(function (response) {
        that.isLoading = false;
        that.makePlan(response.data);
      });
    },
    makePlan: function makePlan(response) {
      if (response.contour !== null) {
        this.initContourPoints = response.contour;
      }
      if (response.walls !== null) {
        this.initPartitions = response.walls;
      }

      if (response.racks.length > 0) {
        this.initRacks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(response.racks.map(function (o) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, o.id, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, o));
        })));
      } else {
        this.initRacks = {};
      }
    },
    loadProducts: function loadProducts(rack) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('/api/v2/products/?rack=' + rack).then(function (response) {
        that.isLoading = false;
        that.makeProducts(response.data);
      });
    },
    makeProducts: function makeProducts(response) {
      this.products = response.results;
    },
    rackClicked: function rackClicked(e) {
      if (this.currentRack !== null) {
        this.$set(this.initRacks[this.currentRack.id], 'selected', false);
      }
      if (this.currentRack !== null && this.currentRack.id === e.id) {
        this.currentRack = null;
      } else {
        this.currentRack = e;
        this.$set(this.initRacks[e.id], 'selected', true);
      }
    },
    rackDblClicked: function rackDblClicked(e) {
      this.$router.push('/pharmacies/' + this.$route.params.id + '/racks/' + e.id + '/');
    },
    planHolderClick: function planHolderClick() {
      this.currentRack = null;
    },
    runOnScroll: function runOnScroll() {},
    loadNextPage: function loadNextPage() {
      //
    }
  },
  computed: {
    /* eslint no-param-reassign: ["error",
     { "props": true, "ignorePropertyModificationsFor": ["point"] }] */
    contour: function contour() {
      if (this.initContourPoints.length > 0) {
        var points = this.initContourPoints.map(function (stat, i) {
          return (i > 0 ? 'L' : '') + ' ' + stat.x + ',' + stat.y;
        }).join(' ');

        return 'M ' + points + ' Z';
      }
      return '';
    },
    partitions: function partitions() {
      return this.initPartitions.map(function (line) {
        line.str = line.map(function (point, i) {
          return (i > 0 ? 'L' : '') + ' ' + point.x + ',' + point.y;
        }).join(' ');
        line.str = 'M ' + line.str;
        return line;
      });
    },
    racks: function racks() {
      return this.initRacks;
    }
  },
  watch: {
    currentRack: function currentRack(val) {
      if (val !== null) {
        this.rack = val.id;
        this.selectedRackName = val.title + ' (' + val.width + 'x' + val.height + 'x' + val.depth + ')';

        this.loadProducts(this.rack);
      } else {
        this.rack = '';
        this.selectedRackName = '';
      }
    }
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rack-on-plan',
  props: {
    id: String,
    title: String,
    index: Number,
    width: Number,
    height: Number,
    depth: Number,
    isExt: Boolean,
    sort: Number,
    angle: {
      type: Number,
      default: 0,
      required: false
    },
    fulfillment: {
      type: Number,
      default: 0,
      required: false
    },
    top: {
      type: Number,
      default: 0,
      required: false
    },
    left: {
      type: Number,
      default: 0,
      required: false
    },
    selected: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    style: function style() {
      return {
        width: this.width / 10 + 'px',
        height: this.depth / 10 + 'px',
        top: this.top + 'px',
        left: this.left + 'px',
        lineHeight: this.depth / 10 + 'px',
        transform: 'rotateZ(' + this.angle + 'deg)',
        // eslint-disable-next-line no-nested-ternary
        borderColor: this.isExt ? 'red' : this.selected ? 'green' : '',
        background: this.selected ? 'rgba(0, 255, 0, 0.2)' : ''
      };
    },
    fulfillmentStyle: function fulfillmentStyle() {
      return {
        width: this.fulfillment + '%'
      };
    }
  },
  methods: {
    contextmenu: function contextmenu(e) {
      this.$emit('contextmenu', {
        id: this.id,
        event: e,
        offsetX: e.clientX - this.left,
        offsetY: e.clientY - this.top,
        x: this.left,
        y: this.top,
        angle: this.angle ? this.angle : 0,
        title: this.title,
        isExt: this.isExt,
        sort: this.sort
      });
    },
    dblclick: function dblclick(e) {
      this.$emit('dblclick', {
        id: this.id,
        event: e
      });
    },
    mousedown: function mousedown(e) {
      if (!e.metaKey) {
        this.$emit('mousedown', {
          id: this.id,
          title: this.title,
          type: 3,
          event: e,
          offsetX: e.clientX - this.left,
          offsetY: e.clientY - this.top,
          x: this.left,
          y: this.top,
          width: this.width,
          height: this.height,
          depth: this.depth
        });
      }
    }
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var TYPE_DEF = 0;
var TYPE_MIDDLE = 1;
var TYPE_WALL = 2;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rack-add',
  props: {},
  computed: {
    /* eslint-disable no-mixed-operators, */
    /* eslint no-param-reassign: ["error",
     { "props": true, "ignorePropertyModificationsFor": ["point","e"] }] */
    placeholder: function placeholder() {
      return '\u0421\u0442\u0435\u043B\u043B\u0430\u0436 ' + this.width + ' x ' + this.height + ' x ' + this.depth + ' \u043C\u043C, ' + this.shelfCount + ' ' + this.plural(this.shelfCount, 'полка', 'полки', 'полок') + ' ';
    },
    rack: function rack() {
      var ratio = Math.min(255 / this.width, 170 / this.depth);
      var height = this.depth * ratio;
      return {
        width: this.width * ratio + 'px',
        height: height + 'px',
        'margin-top': (170 - height) / 2 + 'px'
      };
    },
    rackEditor: function rackEditor() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px',
        'margin-top': this.depth / 2 + 'px'
      };
    },
    viewbox: function viewbox() {
      return '0, 0, ' + this.shelfContourMaxX + ', ' + this.shelfContourMaxY;
    },
    bottomSide: function bottomSide() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px'
      };
    },
    draggablePoints: function draggablePoints() {
      var _this = this;

      var transformed = [];
      this.initContourPoints.forEach(function (point, index) {
        point.id = index;
        transformed.push(point);
        var nextPoint = { type: 1, insertPos: index + 1 };
        if (index < _this.initContourPoints.length - 1) {
          nextPoint.x = point.x + (_this.initContourPoints[index + 1].x - point.x) / 2;
          nextPoint.y = point.y + (_this.initContourPoints[index + 1].y - point.y) / 2;
        } else {
          nextPoint.x = point.x + (_this.initContourPoints[0].x - point.x) / 2;
          nextPoint.y = point.y + (_this.initContourPoints[0].y - point.y) / 2;
        }
        transformed.push(nextPoint);
      });
      return transformed;
    },
    contour: function contour() {
      var points = this.initContourPoints.map(function (stat, i) {
        return (i > 0 ? 'L' : '') + ' ' + stat.x + ',' + stat.y;
      }).join(' ');
      return 'M ' + points + ' Z';
    },
    shelfContour: function shelfContour() {
      var _this2 = this;

      return this.initContourPoints.map(function (element) {
        _this2.shelfContourMaxX = Math.max(_this2.shelfContourMaxX, element.x);
        _this2.shelfContourMaxY = Math.max(_this2.shelfContourMaxY, element.y);
        return element.x + ' ' + element.y;
      }).join(' ');
    }
  },
  watch: {
    placeholder: function placeholder(input) {
      if (this.autoTitleIsOn) {
        this.rName = input;
      }
    }
  },
  methods: {
    plural: function plural(number, one, two, five) {
      var n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return five;
      }
      n %= 10;
      if (n === 1) {
        return one;
      }
      if (n >= 2 && n <= 4) {
        return two;
      }
      return five;
    },
    showEditContour: function showEditContour() {
      if (this.initContourPoints.length === 0) {
        //
        this.initContourPoints.push({ y: 0, x: 0, type: TYPE_DEF });
        this.initContourPoints.push({ y: 0, x: this.width, type: TYPE_DEF });
        this.initContourPoints.push({ y: this.depth, x: this.width, type: TYPE_DEF });
        this.initContourPoints.push({ y: this.depth, x: 0, type: TYPE_DEF });
      }
      this.isInEditContour = true;
    },
    remove: function remove(e) {
      if (e.type === TYPE_DEF) {
        this.initContourPoints.splice(e.id, 1);
      } else if (e.type === TYPE_WALL) {
        this.initPartitions.splice(e.lineIndex, 1);
      }
    },
    mousedown: function mousedown(e) {
      if (e.type === TYPE_MIDDLE) {
        this.initContourPoints.splice(e.insertPos, 0, { x: e.x, y: e.y, type: TYPE_DEF });
        e.id = e.insertPos;
      }
      this.whatToMove = e;
    },
    mousemove: function mousemove(e) {
      var _this3 = this;

      if (this.whatToMove !== null && this.whatToMove !== undefined) {
        if (this.whatToMove.type !== TYPE_WALL) {
          this.$set(this.initContourPoints[this.whatToMove.id], 'y', e.clientY - this.whatToMove.offsetY);
          this.$set(this.initContourPoints[this.whatToMove.id], 'x', e.clientX - this.whatToMove.offsetX);

          this.guides = [];
          this.initContourPoints.forEach(function (element) {
            if (element.id !== _this3.whatToMove.id) {
              // snapping
              if (!e.shiftKey) {
                if (Math.abs(_this3.initContourPoints[_this3.whatToMove.id].y - element.y) < 10) {
                  _this3.initContourPoints[_this3.whatToMove.id].y = element.y;
                }

                if (Math.abs(_this3.initContourPoints[_this3.whatToMove.id].x - element.x) < 10) {
                  _this3.initContourPoints[_this3.whatToMove.id].x = element.x;
                }
              }

              // lines
              if (element.x === _this3.initContourPoints[_this3.whatToMove.id].x) {
                _this3.guides.push({
                  x1: element.x,
                  y1: element.y,
                  x2: element.x,
                  y2: _this3.initContourPoints[_this3.whatToMove.id].y
                });
              }
              if (element.y === _this3.initContourPoints[_this3.whatToMove.id].y) {
                _this3.guides.push({
                  x1: element.x,
                  y1: element.y,
                  x2: _this3.initContourPoints[_this3.whatToMove.id].x,
                  y2: element.y
                });
              }
            }
          });
        }
      }
    },
    mouseup: function mouseup() {
      this.guides = [];
      this.whatToMove = null;
    },
    save: function save() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/rackprototype/', {
        width: this.width,
        depth: this.depth,
        height: this.height,
        title: this.rName || this.placeholder,
        shelfCount: this.shelfCount,
        contour: this.initContourPoints,
        firstShelfY: this.firstShelf

      }).then(function () {
        _this4.$router.go(-1);
      });
    }
  },
  data: function data() {
    return {
      autoTitleIsOn: true,
      rName: '',
      width: 600,
      height: 1800,
      depth: 300,
      shelfCount: 1,
      firstShelf: 600,
      type: '',
      possibleTypes: [{ id: '1', title: 'Прямоугольный' }],
      selectedType: '1',
      //        shelfContour: '',
      shelfContourMaxX: 0,
      shelfContourMaxY: 0,
      initContourPoints: [],
      guides: [],
      isInEditContour: false,
      isChangeContourHappen: false,
      whatToMove: null
    };
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var TYPE_DEF = 0;
var TYPE_MIDDLE = 1;
var TYPE_WALL = 2;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rack-edit',
  created: function created() {
    this.loadPrototype();
  },

  computed: {
    /* eslint-disable no-mixed-operators, */
    /* eslint no-param-reassign: ["error",
     { "props": true, "ignorePropertyModificationsFor": ["point","e"] }] */
    placeholder: function placeholder() {
      return '\u0421\u0442\u0435\u043B\u043B\u0430\u0436 ' + this.width + ' x ' + this.height + ' x ' + this.depth + ' \u043C\u043C, ' + this.shelfCount + ' ' + this.plural(this.shelfCount, 'полка', 'полки', 'полок') + ' ';
    },
    rack: function rack() {
      var ratio = Math.min(255 / this.width, 170 / this.depth);
      var height = this.depth * ratio;
      return {
        width: this.width * ratio + 'px',
        height: height + 'px',
        'margin-top': (170 - height) / 2 + 'px'
      };
    },
    rackEditor: function rackEditor() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px',
        'margin-top': this.depth / 2 + 'px'
      };
    },
    viewbox: function viewbox() {
      return '0, 0, ' + this.shelfContourMaxX + ', ' + this.shelfContourMaxY;
    },
    bottomSide: function bottomSide() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px'
      };
    },
    draggablePoints: function draggablePoints() {
      var _this = this;

      var transformed = [];
      this.initContourPoints.forEach(function (point, index) {
        point.id = index;
        transformed.push(point);
        var nextPoint = { type: 1, insertPos: index + 1 };
        if (index < _this.initContourPoints.length - 1) {
          nextPoint.x = point.x + (_this.initContourPoints[index + 1].x - point.x) / 2;
          nextPoint.y = point.y + (_this.initContourPoints[index + 1].y - point.y) / 2;
        } else {
          nextPoint.x = point.x + (_this.initContourPoints[0].x - point.x) / 2;
          nextPoint.y = point.y + (_this.initContourPoints[0].y - point.y) / 2;
        }
        transformed.push(nextPoint);
      });
      return transformed;
    },
    contour: function contour() {
      var points = this.initContourPoints.map(function (stat, i) {
        return (i > 0 ? 'L' : '') + ' ' + stat.x + ',' + stat.y;
      }).join(' ');
      return 'M ' + points + ' Z';
    },
    shelfContour: function shelfContour() {
      var _this2 = this;

      return this.initContourPoints.map(function (element) {
        _this2.shelfContourMaxX = Math.max(_this2.shelfContourMaxX, element.x);
        _this2.shelfContourMaxY = Math.max(_this2.shelfContourMaxY, element.y);
        return element.x + ' ' + element.y;
      }).join(' ');
    }
  },
  watch: {
    placeholder: function placeholder(input) {
      if (this.autoTitleIsOn) {
        this.rName = input;
      }
    }
  },
  methods: {
    loadPrototype: function loadPrototype() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/prototypes/' + this.$route.params.rack).then(function (response) {
        self.isLoading = false;
        self.makeRack(response.data);
      });
    },
    makeRack: function makeRack(response) {
      this.rackprototype = response;
      this.rName = this.rackprototype.title;
      this.width = this.rackprototype.width;
      this.height = this.rackprototype.height;
      this.depth = this.rackprototype.depth;
      this.shelfCount = this.rackprototype.shelfCount;
      this.firstShelf = this.rackprototype.firstShelfY;
    },
    plural: function plural(number, one, two, five) {
      var n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return five;
      }
      n %= 10;
      if (n === 1) {
        return one;
      }
      if (n >= 2 && n <= 4) {
        return two;
      }
      return five;
    },
    showEditContour: function showEditContour() {
      if (this.initContourPoints.length === 0) {
        //
        this.initContourPoints.push({ y: 0, x: 0, type: TYPE_DEF });
        this.initContourPoints.push({ y: 0, x: this.width, type: TYPE_DEF });
        this.initContourPoints.push({ y: this.depth, x: this.width, type: TYPE_DEF });
        this.initContourPoints.push({ y: this.depth, x: 0, type: TYPE_DEF });
      }
      this.isInEditContour = true;
    },
    remove: function remove(e) {
      if (e.type === TYPE_DEF) {
        this.initContourPoints.splice(e.id, 1);
      } else if (e.type === TYPE_WALL) {
        this.initPartitions.splice(e.lineIndex, 1);
      }
    },
    mousedown: function mousedown(e) {
      if (e.type === TYPE_MIDDLE) {
        this.initContourPoints.splice(e.insertPos, 0, { x: e.x, y: e.y, type: TYPE_DEF });
        e.id = e.insertPos;
      }
      this.whatToMove = e;
    },
    mousemove: function mousemove(e) {
      var _this3 = this;

      if (this.whatToMove !== null && this.whatToMove !== undefined) {
        if (this.whatToMove.type !== TYPE_WALL) {
          this.$set(this.initContourPoints[this.whatToMove.id], 'y', e.clientY - this.whatToMove.offsetY);
          this.$set(this.initContourPoints[this.whatToMove.id], 'x', e.clientX - this.whatToMove.offsetX);

          this.guides = [];
          this.initContourPoints.forEach(function (element) {
            if (element.id !== _this3.whatToMove.id) {
              // snapping
              if (!e.shiftKey) {
                if (Math.abs(_this3.initContourPoints[_this3.whatToMove.id].y - element.y) < 10) {
                  _this3.initContourPoints[_this3.whatToMove.id].y = element.y;
                }

                if (Math.abs(_this3.initContourPoints[_this3.whatToMove.id].x - element.x) < 10) {
                  _this3.initContourPoints[_this3.whatToMove.id].x = element.x;
                }
              }

              // lines
              if (element.x === _this3.initContourPoints[_this3.whatToMove.id].x) {
                _this3.guides.push({
                  x1: element.x,
                  y1: element.y,
                  x2: element.x,
                  y2: _this3.initContourPoints[_this3.whatToMove.id].y
                });
              }
              if (element.y === _this3.initContourPoints[_this3.whatToMove.id].y) {
                _this3.guides.push({
                  x1: element.x,
                  y1: element.y,
                  x2: _this3.initContourPoints[_this3.whatToMove.id].x,
                  y2: element.y
                });
              }
            }
          });
        }
      }
    },
    mouseup: function mouseup() {
      this.guides = [];
      this.whatToMove = null;
    },
    save: function save() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/rackprototype/' + this.rackprototype.id, {
        width: this.width,
        depth: this.depth,
        height: this.height,
        title: this.rName || this.placeholder,
        shelfCount: this.shelfCount,
        contour: this.initContourPoints,
        firstShelfY: this.firstShelf

      }).then(function () {
        _this4.$router.go(-1);
      });
    }
  },
  data: function data() {
    return {
      autoTitleIsOn: false,
      rName: '',
      width: 600,
      height: 1800,
      depth: 300,
      shelfCount: 1,
      firstShelf: 600,
      type: '',
      possibleTypes: [{ id: '1', title: 'Прямоугольный' }],
      selectedType: '1',
      //        shelfContour: '',
      shelfContourMaxX: 0,
      shelfContourMaxY: 0,
      initContourPoints: [],
      guides: [],
      isInEditContour: false,
      isChangeContourHappen: false,
      whatToMove: null,
      rackprototype: { racks: {} }
    };
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rack-list',
  data: function data() {
    return {
      racks: [],
      pharmacy: this.$route.params.id,
      copyTo: {},
      navClass: ''
    };
  },

  watch: {
    $route: function $route(to, from) {
      if (from.params.rack !== to.params.rack) {
        this.loadRacks();
      }
    }
  },
  components: { selectMaterial: __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial___default.a },
  methods: {
    loadRacks: function loadRacks() {
      var self = this;

      if (this.$route.params.rack) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/racks/' + this.$route.params.rack + '/').then(function (response) {
          self.isLoading = false;
          self.racks = [response.data];
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/racks/?pharmacy=' + self.pharmacy).then(function (response) {
          self.isLoading = false;
          self.racks = response.data;
        });
      }
    },
    navClicked: function navClicked(rack) {
      var box = document.getElementById(rack).getBoundingClientRect();
      // console.log(box);
      window.scrollTo(0, box.top + window.pageYOffset);
    },
    handleScroll: function handleScroll() {
      this.navClass = window.scrollY > 215 ? 'fixed' : '';
    },
    removeLink: function removeLink(id) {
      var self = this;
      if (confirm('Удалить свять с эталонной полкой?')) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/v2/shelfs/' + id + '/', { template_shelf: null }).then(function () {
          self.loadRacks();
        });
      }
    }
  },

  created: function created() {
    this.loadRacks();
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__html_InputMaterial__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__html_InputMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__html_InputMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DropZone__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DropZone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DropZone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pack__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Pack__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'product-edit',
  methods: {
    load: function load() {
      var _this = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/api/v2/products/' + this.$route.params.id + '/').then(function (response) {
        that.isLoading = false;

        _this.product = response.data;
        if (_this.product.photos.length > 0) {
          var temp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(_this.product.photos.map(function (o) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, o.side, o.photo50);
          })));

          console.log(temp);

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(temp).forEach(function (el) {
            _this.photos[el] = temp[el];
          });
        }
      });
    },
    frontUploaded: function frontUploaded(response) {
      this.photos.FRONT = response.image;
    },
    topUploaded: function topUploaded(response) {
      this.photos.TOP = response.image;
    },
    leftUploaded: function leftUploaded(response) {
      this.photos.LEFT = response.image;
    },
    rightUploaded: function rightUploaded(response) {
      this.photos.RIGHT = response.image;
    },
    backUploaded: function backUploaded(response) {
      this.photos.BACK = response.image;
    },
    bottomUploaded: function bottomUploaded(response) {
      this.photos.BOTTOM = response.image;
    },
    save: function save() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.patch('/api/product/' + this.product.id, {
        width: this.width || 0,
        height: this.height || 0,
        depth: this.depth || 0
      }).then(function () {
        _this2.$router.replace({ path: '/products/' });
      });
    }
  },
  watch: {
    $route: function $route(to) {
      if (!to.params.id) {
        this.$router.replace({ path: '/products/' });
      }
    }
  },
  data: function data() {
    return {
      bodyClassName: 'no-overflow',
      width: 0,
      height: 0,
      depth: 0,
      product: {},
      photos: {
        FRONT: '',
        BACK: '',
        TOP: '',
        BOTTOM: '',
        LEFT: '',
        RIGHT: ''
      },
      currentCameraView: 'right',
      currentCameraZoom: 2,
      previousCameraZoom: 2,
      cameraViews: {
        right: { title: 'Справа', id: 'right', rotationX: -20, rotationY: -20 },
        top: { title: 'Сверху', id: 'top', rotationX: -91, rotationY: 0 },
        back: { title: 'Сзади', id: 'back', rotationX: 0, rotationY: 180 },
        front: { title: 'Фронт', id: 'front', rotationX: -10, rotationY: 0 }
      },
      cameraZooms: {
        right: { title: '25%', value: 1 },
        top: { title: '50%', value: 2 },
        back: { title: '75%', value: 3 },
        front: { title: '100%', value: 4 }
      }
    };
  },

  computed: {
    scaleFactor: function scaleFactor() {
      //      let scaleFactor = 1;
      //      scaleFactor = Math.min(scaleFactor, 575 / (this.width + this.depth + this.height));

      return this.currentCameraZoom;
    },
    previewWidth: function previewWidth() {
      return this.width * this.scaleFactor;
    },
    previewHeight: function previewHeight() {
      return this.height * this.scaleFactor;
    },
    previewDepth: function previewDepth() {
      return this.depth * this.scaleFactor;
    },
    packStyle: function packStyle() {
      return {
        transform: 'translate3d(-110px, -10px,0px)'
      };
    },
    cameraPosition: function cameraPosition() {
      return {
        transform: 'rotateX(' + this.cameraViews[this.currentCameraView].rotationX + 'deg) rotateY(' + this.cameraViews[this.currentCameraView].rotationY + 'deg)'
      };
    }
  },
  created: function created() {
    this.load();
    document.body.classList.add(this.bodyClassName);
  },
  destroyed: function destroyed() {
    document.body.classList.remove(this.bodyClassName);
  },

  components: { inputMaterial: __WEBPACK_IMPORTED_MODULE_5__html_InputMaterial___default.a, dropZone: __WEBPACK_IMPORTED_MODULE_6__DropZone___default.a, pack: __WEBPACK_IMPORTED_MODULE_7__Pack___default.a }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditableTD__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EditableTD___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EditableTD__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductEdit__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ProductEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ProductEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__html_InputMaterial__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__html_InputMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__html_InputMaterial__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-unused-vars,spaced-comment */









__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'products-table',
  created: function created() {
    this.load('', true);
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.runOnScroll);
  },

  watch: {
    searchStr: function searchStr(val) {
      this.load(val, true);
    }
  },
  data: function data() {
    return {
      searchStr: '',
      products: [],
      productList: [],
      isLoading: false,
      next: null
    };
  },

  methods: {
    inputStr: __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]._.debounce(function mutated(input) {
      this.searchStr = input;
    }, 500),
    load: function load(search, clearList) {
      this.loadURL('/api/v2/products/?search=' + search, clearList);
    },
    loadURL: function loadURL(url, clearList) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url).then(function (response) {
        that.isLoading = false;
        that.makeList(response.data, clearList);
      });
    },
    makeList: function makeList(response, clearList) {
      var _this = this;

      if (clearList) {
        this.productList = [];
      }
      this.next = response.next;
      if (response.results.length > 0) {
        response.results.forEach(function (product) {
          var productCopy = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, product);
          if (product.photos.length > 0) {
            productCopy.photos = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(product.photos.map(function (o) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, o.side, o.photo50);
            })));
          }
          _this.productList.push(productCopy);
        });
      }
    },
    runOnScroll: function runOnScroll() {
      if (this.next != null) {
        if (this.$refs.nextLink.offsetParent.scrollTop + window.outerHeight + 150 > this.$refs.nextLink.offsetTop) {
          this.loadNextPage();
        }
      }
    },
    loadNextPage: function loadNextPage() {
      if (!this.isLoading && this.next != null) {
        this.isLoading = true;
        this.loadURL(this.next, false);
      }
    }
  },
  components: {
    MaterialInput: __WEBPACK_IMPORTED_MODULE_9__html_InputMaterial___default.a,
    ProductEdit: __WEBPACK_IMPORTED_MODULE_8__ProductEdit___default.a,
    editableTd: __WEBPACK_IMPORTED_MODULE_7__EditableTD___default.a }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'version-add',
  created: function created() {
    this.loadPharmacies();
  },

  methods: {
    loadPharmacies: function loadPharmacies() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/pharmacies/?is_template=false').then(function (response) {
        that.pharmacies = response.data;
      });
    },
    save: function save() {
      var self = this;
      var data = { pharmacies: this.pharmaciesSelected };

      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/v2/versions/', data).then(function () {
        self.loading = false;
        self.returnBack();
      });
    },
    returnBack: function returnBack() {
      this.$router.push('../');
    }
  },
  data: function data() {
    return {
      loading: false,
      pharmacies: [],
      pharmaciesSelected: []
    };
  },

  components: { selectMaterial: __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial___default.a }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reports',
  created: function created() {
    this.loadVersions();
  },

  methods: {
    loadVersions: function loadVersions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/versions/pharmacies/').then(function (response) {
        self.isLoading = false;
        self.pharmacies = response.data;
      });
    },
    save: function save() {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/pushnewversion/', {}).then(function () {
        document.location.reload();
      });
    }
  },
  data: function data() {
    return {
      pharmacies: [],
      statuses: {
        NEW: 'Новая версия',
        SEEN: 'В работе',
        DONE: 'Сделано'
      }
    };
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShelfEditor__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShelfEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ShelfEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShelfView__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShelfView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ShelfView__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-unused-vars */









__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_4_lodash___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      searchStr: '',
      productList: [],
      currentPage: '/api/products/',
      isLoading: false,
      next: null,
      onlyAdd: false,
      onlyRemove: false,
      isHM: this.$store.state.user.role === 'HM',
      roleClass: this.$store.state.user.role === 'HM' ? 'hm' : 'pm'
    };
  },

  methods: {
    load: function load(clearList) {
      if (this.isHM) {
        this.loadURL('/api/v2/products/?pharmacy=' + this.$route.params.id + '&search=' + this.searchStr + '&onlyAdd=' + this.onlyAdd + '&onlyRemove=' + this.onlyRemove, clearList);
      } else {
        this.loadURL('/api/v2/products/?shelf=' + this.$route.params.shelf + '&search=' + this.searchStr + '&onlyAdd=' + this.onlyAdd + '&onlyRemove=' + this.onlyRemove, clearList);
      }
    },
    loadURL: function loadURL(url, clearList) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url).then(function (response) {
        that.isLoading = false;
        that.makeList(response.data, clearList);
      });
    },
    makeList: function makeList(response, clearList) {
      var _this = this;

      if (clearList) {
        this.productList = [];
      }
      this.next = response.next;
      if (response.results.length > 0) {
        response.results.forEach(function (product) {
          var productCopy = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, product);
          if (product.photos.length > 0) {
            productCopy.photos = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(product.photos.map(function (o) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, o.side, o.photo50);
            })));
          }
          _this.productList.push(productCopy);
        });
      }
    },
    add: function add(product) {
      // eslint-disable-next-line no-undef
      if (this.$store.state.user.role === 'HM') {
        this.$emit('addProduct', product);
      }
    },


    inputStr: __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]._.debounce(function mutated(input) {
      this.searchStr = input;
    }, 500),
    runOnScroll: function runOnScroll() {
      if (this.hasNext) {
        if (this.$refs.nextLink.offsetParent.scrollTop + window.outerHeight + 150 > this.$refs.nextLink.offsetTop) {
          this.loadNextPage();
        }
      }
    },
    loadNextPage: function loadNextPage() {
      if (!this.isLoading && this.next != null) {
        this.isLoading = true;
        this.loadURL(this.next, false);
      }
    }
  },
  watch: {
    searchStr: function searchStr() {
      this.load(true);
    },
    onlyAdd: function onlyAdd() {
      this.load(true);
    },
    onlyRemove: function onlyRemove() {
      this.load(true);
    }
  },
  computed: {
    rackShelfInfo: function rackShelfInfo() {
      return this.$store.state.shelf !== null ? this.$store.state.shelf.rack.title + ' / #' + this.$store.state.shelf.number : '';
    }
  },
  created: function created() {
    var self = this;
    self.load('', true);
    this.$parent.$on('save', function () {
      self.$emit('save');
    });
  },

  components: { Shelf: __WEBPACK_IMPORTED_MODULE_7__ShelfEditor___default.a, ShelfView: __WEBPACK_IMPORTED_MODULE_8__ShelfView___default.a }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_for_each__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_for_each___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_for_each__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_html2canvas__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-unused-vars, eslint-disable max-len, no-mixed-operators, no-param-reassign, max-len */




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'shelf',
  props: {
    id: {
      type: String,
      required: true
    },
    x: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data: function data() {
    return {
      packs: [],
      whatToMove: null,
      groupToMove: [],
      zIndex: 0,
      spaceIsPressed: false,
      mousePositionBaked: null,
      diffX: 0,
      diffY: 0,
      left: 0,
      top: 0,
      currentCameraView: 'right',
      screenshot: false,
      cameraViews: {
        right: { title: 'Справа', id: 'right', rotationX: -20, rotationY: -20 },
        top: { title: 'Сверху', id: 'top', rotationX: -91, rotationY: 0 },
        back: { title: 'Сзади', id: 'back', rotationX: 0, rotationY: 180 },
        front: { title: 'Фронт', id: 'front', rotationX: -10, rotationY: 0 },
        leftBottom: { title: 'Слева снизу', id: 'leftBottom', rotationX: 20, rotationY: 20 }
      },
      currentCameraZoom: 2,
      previousCameraZoom: 2,
      cameraZooms: {
        right: { title: '25%', value: 1 },
        top: { title: '50%', value: 2 },
        back: { title: '75%', value: 3 },
        front: { title: '100%', value: 4 }
      },
      shelfContour: '',
      shelfWidth: 0,
      shelfHeight: 0,
      shelfContourMaxX: 0,
      shelfContourMaxY: 0,
      initWidth: 0,
      initHeight: 0,
      initDepth: 0,
      topSideIsVisible: true,
      bottomSideIsVisible: true
    };
  },

  watch: {
    currentCameraZoom: function currentCameraZoom(newCameraZoom) {
      var _this = this;

      this.packs.forEach(function (pack) {
        pack.x = pack.x / _this.previousCameraZoom * newCameraZoom;
        pack.y = pack.y / _this.previousCameraZoom * newCameraZoom;
        pack.z = pack.z / _this.previousCameraZoom * newCameraZoom;
      });
    }
  },
  methods: {
    loadShelf: function loadShelf() {
      var _this2 = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('/api/v2/shelfs/' + this.id + '/').then(function (response) {
        that.isLoading = false;
        _this2.makeShelf(response.data);
      });
    },
    makeShelf: function makeShelf(response) {
      var _this3 = this;

      this.$store.commit('shelf', response);

      this.packs = [];

      this.initWidth = response.rack.prototype.width;
      this.initHeight = (response.rack.prototype.height - response.rack.prototype.firstShelfY) / response.rack.prototype.shelfCount;
      this.initDepth = response.rack.prototype.depth;

      this.shelfContour = response.rack.prototype.contour.map(function (element) {
        _this3.shelfContourMaxX = Math.max(_this3.shelfContourMaxX, element.x);
        _this3.shelfContourMaxY = Math.max(_this3.shelfContourMaxY, element.y);
        return element.x + ' ' + element.y;
      }).join(' ');

      this.shelfWidth = response.rack.prototype.width;
      this.shelfHeight = response.rack.prototype.depth;

      if (response.items.length > 0) {
        response.items.forEach(function (element, key) {
          var photos = {};

          if (element.product.photos.length > 0) {
            photos = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(element.product.photos.map(function (o) {
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, o.side, o.photo400);
            })));
          } else {
            photos = {
              FRONT: '',
              BACK: '',
              TOP: '',
              RIGHT: '',
              LEFT: '',
              BOTTOM: ''
            };
          }
          var pack = {
            pos: element.orientation === 'DEFAULT' ? 0 : 1,
            width: element.product.width,
            initHeight: element.product.height,
            initDepth: element.product.depth,
            initFrontImg: photos.FRONT || '',
            initBackImg: photos.BACK || '',
            initTopImg: photos.TOP || '',
            initRightImg: photos.RIGHT || '',
            initLeftImg: photos.LEFT || '',
            initBottomImg: photos.BOTTOM || '',
            dominantColor: element.product.dominantColor || '',
            isMirrored: false,
            x: element.x,
            y: element.y,
            z: element.z,
            zIndex: 1,
            product: element.product.id,
            selected: false,
            size: {},
            existedId: element.id,
            existed: true
          };

          _this3.packs.push(pack);
        });
      }
    },
    spacePressed: function spacePressed(e) {
      if (e.keyCode === 32) {
        if (e.target.tagName.toUpperCase() === 'BODY') {
          e.preventDefault();
          this.spaceIsPressed = true;
          this.whatToMove = null;
        }
      }
    },
    spaceUp: function spaceUp(e) {
      if (e.keyCode === 32) {
        this.spaceIsPressed = false;
        this.mousePositionBaked = null;
      }
    },
    mousedownShelf: function mousedownShelf(e) {
      if (this.spaceIsPressed) {
        e.stopPropagation();
        this.mousePositionBaked = {
          x: e.pageX,
          y: e.pageY,
          shelfLeft: this.left,
          shelfTop: this.top
        };
      }
    },
    mousedownPack: function mousedownPack(e) {
      // if (this.whatToMove === null) {
      this.whatToMove = e;
      // } else {
      //   this.whatToMove = null;
      // }
    },
    mousemove: function mousemove(e) {
      var _this4 = this;

      if (this.whatToMove !== null) {
        if (this.whatToMove.side === 'front') {
          //

          if (this.groupToMove.length === 0) {
            this.groupToMove.push(this.whatToMove);
          }

          var yChange = 0;
          var xChange = 0;

          this.groupToMove.filter(function (pack) {
            return pack.id === _this4.whatToMove.id;
          }).forEach(function (pack) {
            var topSidePos = e.clientY - _this4.whatToMove.offsetY;
            var maxTopSidePos = _this4.height - _this4.packs[_this4.whatToMove.id].size.height;

            var leftSidePos = e.clientX - _this4.whatToMove.offsetX;
            var maxLeftSidePos = _this4.width - _this4.packs[_this4.whatToMove.id].size.width;

            var yNewPos = Math.max(0, Math.min(topSidePos, maxTopSidePos));
            var xNewPos = Math.max(0, Math.min(leftSidePos, maxLeftSidePos));

            yChange = _this4.packs[_this4.whatToMove.id].y - yNewPos;
            xChange = _this4.packs[_this4.whatToMove.id].x - xNewPos;

            _this4.$set(_this4.packs[_this4.whatToMove.id], 'y', yNewPos);
            _this4.$set(_this4.packs[_this4.whatToMove.id], 'x', xNewPos);
          });

          this.groupToMove.filter(function (pack) {
            return pack.id !== _this4.whatToMove.id;
          }).forEach(function (pack) {
            _this4.$set(_this4.packs[pack.id], 'y', _this4.packs[pack.id].y - yChange);
            _this4.$set(_this4.packs[pack.id], 'x', _this4.packs[pack.id].x - xChange);
          });
        } else {
          this.packs[this.whatToMove.id].z = Math.min(0, e.clientY - this.whatToMove.offsetZ);
        }
      } else if (this.spaceIsPressed && this.mousePositionBaked !== null) {
        this.left = this.mousePositionBaked.shelfLeft - (this.mousePositionBaked.x - e.pageX);
        this.top = this.mousePositionBaked.shelfTop - (this.mousePositionBaked.y - e.pageY);
      }
    },
    mouseup: function mouseup(e) {
      this.whatToMove = null;
      if (this.groupToMove.length === 1 && !e.altKey) {
        this.groupToMove = [];
      }
    },
    mouseleave: function mouseleave(e) {
      this.whatToMove = null;
    },
    packSizeCalculated: function packSizeCalculated(e) {
      this.packs[e.id].size = e.size;
    },
    removePack: function removePack(ind) {
      this.packs.splice(ind, 1);
    },
    rotate: function rotate(ind) {
      this.$set(this.packs[ind], 'pos', this.packs[ind].pos === 0 ? 1 : 0);
    },
    addProduct: function addProduct(product) {
      var photos = {
        FRONT: '',
        BACK: '',
        TOP: '',
        RIGHT: '',
        LEFT: '',
        BOTTOM: ''
      };

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(product.photos).forEach(function (key) {
        photos[key] = product.photos[key];
      });

      var pack = {
        pos: 0,
        width: product.width,
        initHeight: product.height,
        initDepth: product.depth,
        initFrontImg: photos.FRONT || '',
        initBackImg: photos.BACK || '',
        initTopImg: photos.TOP || '',
        initRightImg: photos.RIGHT || '',
        initLeftImg: photos.LEFT || '',
        initBottomImg: photos.BOTTOM || '',
        isMirrored: false,
        x: 0,
        y: 0,
        z: 0,
        zIndex: 1,
        product: product.id,
        selected: false,
        size: {},
        existed: false
      };

      this.packs.push(pack);
    },
    save: function save() {
      var _this5 = this;

      this.screenshot = true;
      this.currentCameraView = 'front';
      this.previousCameraZoom = this.currentCameraZoom;
      this.currentCameraZoom = 2;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_7_html2canvas___default()(document.querySelector('#shelf')).then(function (canvas) {
          var items = _this5.packs.map(function (item) {
            var toPublish = {
              product: item.product,
              x: Math.ceil(item.x),
              y: Math.ceil(item.y),
              z: Math.ceil(item.z),
              orientation: item.pos === 0 ? 'DEFAULT' : 'FACE_TOP'
            };

            if (item.existed) {
              toPublish.id = item.existedId;
            }
            return toPublish;
          });
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.patch('/api/shelf/' + _this5.id + '/', {
            items: items,
            photo: canvas.toDataURL()
          }).then(function () {
            _this5.screenshot = false;
            _this5.$router.push('../');
          });
        });
      }, 300);
    },
    click: function click(e) {
      if (this.groupToMove.filter(function (pack) {
        return pack.id === e;
      }).length === 0) {
        this.packs.forEach(function (pack) {
          pack.selected = false;
        });
        this.groupToMove = [];
      }
    },
    moveToSide: function moveToSide(e) {
      if (e.side === 'top') {
        this.movePackToBottom(e);
      }

      if (e.side === 'bottom') {
        this.movePackToTop(e);
      }

      if (e.side === 'right') {
        this.movePackToLeft(e);
      }

      if (e.side === 'left') {
        this.movePackToRight(e);
      }

      if (e.side === 'front') {
        this.movePackToFront(e);
      }

      if (e.side === 'back') {
        this.movePackToBack(e);
      }
    },
    select: function select(e) {
      if (this.groupToMove.filter(function (value) {
        return value.id === e.id;
      }).length === 0) {
        this.groupToMove.push(e);
        this.packs[e.id].selected = true;
      } else {
        this.groupToMove.splice(this.groupToMove.findIndex(function (value) {
          return value.id === e.id;
        }), 1);
        this.packs[e.id].selected = false;
      }
    },
    movePackToLeft: function movePackToLeft(e) {
      var packWeMove = this.packs[e.id];
      var minX = 0;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_for_each___default()(this.packs, function (pack, index) {
        if (index !== packWeMove.id) {
          if (pack.x < packWeMove.x) {
            //
            // Z-line
            var z0 = Math.abs(pack.z);
            var z1 = z0 + pack.size.depth;

            var a0 = Math.abs(packWeMove.z);
            var a1 = a0 + packWeMove.size.depth;

            if (z0 >= a0 && z1 <= a1 || a0 >= z0 && a0 <= z1 || z0 >= a0 && z0 <= a1 || a1 >= z0 && a1 <= z1 || a1 >= z0 && a1 <= z1 || a0 <= z0 && a1 >= z0) {
              //

              var y0 = pack.y;
              var y1 = pack.y + pack.size.height;

              var b0 = packWeMove.y;
              var b1 = packWeMove.y + packWeMove.size.height;

              if (y0 >= b0 && y1 <= b0 || y0 <= b1 && y1 >= b1 || y0 <= b0 && y1 >= b1 || b0 <= y0 && b1 >= y1) {
                minX = Math.max(minX, pack.x + pack.size.width + 1);
              }
              //
            }
          }
        }
      });
      this.$set(packWeMove, 'x', minX);
    },
    movePackToRight: function movePackToRight(e) {
      var packWeMove = this.packs[e.id];
      var maxX = this.width - packWeMove.size.width;
      var packEndX = packWeMove.x + packWeMove.size.width;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_for_each___default()(this.packs, function (pack, index) {
        if (index !== packWeMove.id) {
          if (pack.x > packEndX) {
            // Z-line
            var z0 = Math.abs(pack.z);
            var z1 = z0 + pack.size.depth;

            var a0 = Math.abs(packWeMove.z);
            var a1 = a0 + packWeMove.size.depth;

            if (z0 >= a0 && z1 <= a1 || a0 >= z0 && a0 <= z1 || z0 >= a0 && z0 <= a1 || a1 >= z0 && a1 <= z1 || a1 >= z0 && a1 <= z1 || a0 <= z0 && a1 >= z0) {
              var y0 = pack.y;
              var y1 = pack.y + pack.size.height;

              var b0 = packWeMove.y;
              var b1 = packWeMove.y + packWeMove.size.height;

              if (y0 >= b0 && y1 <= b0 || y0 <= b1 && y1 >= b1 || y0 <= b0 && y1 >= b1 || b0 <= y0 && b1 >= y1) {
                maxX = Math.min(maxX, pack.x - packWeMove.size.width - 1);
              }
            }
          }
        }
      });
      this.$set(packWeMove, 'x', maxX);
    },
    movePackToBottom: function movePackToBottom(e) {
      var packWeMove = this.packs[e.id];
      var maxY = this.height - packWeMove.size.height;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_for_each___default()(this.packs, function (pack, index) {
        if (index !== e.id) {
          if (pack.y > packWeMove.y) {
            var z0 = Math.abs(pack.z);
            var z1 = z0 + pack.size.depth;

            var a0 = Math.abs(packWeMove.z);
            var a1 = a0 + packWeMove.size.depth;

            if (z0 >= a0 && z1 <= a1 || a0 >= z0 && a0 <= z1 || z0 >= a0 && z0 <= a1 || a1 >= z0 && a1 <= z1 || a1 >= z0 && a1 <= z1 || a0 <= z0 && a1 >= z0) {
              var x0 = pack.x;
              var x1 = pack.x + pack.size.width;

              var b0 = packWeMove.x;
              var b1 = packWeMove.x + packWeMove.size.width;
              if (x0 <= b0 && x1 >= b0 || x0 <= b1 && x1 >= b1 || x0 >= b0 && x1 <= b1 || b0 >= x0 && b1 <= x1) {
                maxY = Math.min(maxY, pack.y - packWeMove.size.height - 1);
              }
              //
            }
          }
        }
      });
      this.$set(packWeMove, 'y', maxY);
    },
    movePackToTop: function movePackToTop(e) {
      var packWeMove = this.packs[e.id];
      var minY = 0;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_for_each___default()(this.packs, function (pack, index) {
        if (index !== e.id) {
          if (pack.y + pack.size.height < packWeMove.y) {
            var z0 = Math.abs(pack.z);
            var z1 = z0 + pack.size.depth;

            var a0 = Math.abs(packWeMove.z);
            var a1 = a0 + packWeMove.size.depth;

            if (z0 >= a0 && z1 <= a1 || a0 >= z0 && a0 <= z1 || z0 >= a0 && z0 <= a1 || a1 >= z0 && a1 <= z1 || a1 >= z0 && a1 <= z1 || a0 <= z0 && a1 >= z0) {
              var x0 = pack.x;
              var x1 = pack.x + pack.size.width;

              var b0 = packWeMove.x;
              var b1 = packWeMove.x + packWeMove.size.width;
              if (x0 <= b0 && x1 >= b0 || x0 <= b1 && x1 >= b1 || x0 >= b0 && x1 <= b1 || b0 >= x0 && b1 <= x1) {
                minY = Math.max(minY, pack.y + pack.size.height + 1);
              }
            }
          }
        }
      });
      this.$set(packWeMove, 'y', minY);
    },
    movePackToFront: function movePackToFront(e) {
      var packWeMove = this.packs[e.id];
      var maxZ = 0;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_for_each___default()(this.packs, function (pack, index) {
        if (index !== e.id) {
          if (pack.z > packWeMove.z) {
            var y0 = pack.y;
            var y1 = pack.y + pack.size.height;

            var a0 = packWeMove.y;
            var a1 = packWeMove.y + packWeMove.size.height;

            if (y0 >= a0 && y1 <= a0 || y0 <= a1 && y1 >= a1 || y0 <= a0 && y1 >= a1 || a0 <= y0 && a1 >= y1) {
              var x0 = pack.x;
              var x1 = pack.x + pack.size.width;

              var b0 = packWeMove.x;
              var b1 = packWeMove.x + packWeMove.size.width;

              if (x0 <= b0 && x1 >= b0 || x0 <= b1 && x1 >= b1 || x0 >= b0 && x1 <= b1 || b0 >= x0 && b1 <= x1) {
                maxZ = Math.min(maxZ, pack.z - pack.size.depth - 1);
              }
            }
          }
        }
      });
      this.$set(packWeMove, 'z', maxZ);
    },
    movePackToBack: function movePackToBack(e) {
      var packWeMove = this.packs[e.id];
      var minZ = -(this.depth - packWeMove.size.depth);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_for_each___default()(this.packs, function (pack, index) {
        if (index !== e.id) {
          if (pack.z < packWeMove.z) {
            var y0 = pack.y;
            var y1 = pack.y + pack.size.height;

            var a0 = packWeMove.y;
            var a1 = packWeMove.y + packWeMove.size.height;

            if (y0 >= a0 && y1 <= a0 || y0 <= a1 && y1 >= a1 || y0 <= a0 && y1 >= a1 || a0 <= y0 && a1 >= y1) {
              var x0 = pack.x;
              var x1 = pack.x + pack.size.width;

              var b0 = packWeMove.x;
              var b1 = packWeMove.x + packWeMove.size.width;

              if (x0 <= b0 && x1 >= b0 || x0 <= b1 && x1 >= b1 || x0 >= b0 && x1 <= b1 || b0 >= x0 && b1 <= x1) {
                minZ = Math.max(minZ, pack.z + packWeMove.size.depth + 1);
              }
            }
          }
        }
      });
      this.$set(packWeMove, 'z', minZ);
    },
    fillWidth: function fillWidth(lineUpZ, lineUpY) {
      var _this6 = this;

      var sumOfWidths = this.groupToMove.reduce(function (previousValue, currentValue) {
        return previousValue + _this6.packs[currentValue.id].size.width;
      }, 0);
      if (sumOfWidths <= this.width) {
        var spaceBetween = (this.width - sumOfWidths) / (this.groupToMove.length - 1);
        var nextX = 0;
        var firstZ = this.groupToMove[0].z;
        var firstY = this.groupToMove[0].y;
        this.groupToMove.forEach(function (pack) {
          _this6.$set(_this6.packs[pack.id], 'x', nextX);
          if (lineUpZ) {
            _this6.$set(_this6.packs[pack.id], 'z', firstZ);
          }
          if (lineUpY) {
            _this6.$set(_this6.packs[pack.id], 'y', firstY);
          }
          nextX += spaceBetween + _this6.packs[pack.id].size.width;
        });
      } else {
        alert('Операция невозможна');
      }
    },
    fillHeight: function fillHeight(lineUpZ, lineUpX) {
      var _this7 = this;

      var sumOfHeights = this.groupToMove.reduce(function (previousValue, currentValue) {
        return previousValue + _this7.packs[currentValue.id].size.height;
      }, 0);
      if (sumOfHeights <= this.height) {
        var spaceBetween = (this.height - sumOfHeights) / (this.groupToMove.length - 1);
        var nextY = 0;
        var firstZ = this.groupToMove[0].z;
        var firstX = this.groupToMove[0].x;
        this.groupToMove.forEach(function (pack) {
          _this7.$set(_this7.packs[pack.id], 'y', nextY);
          if (lineUpZ) {
            _this7.$set(_this7.packs[pack.id], 'z', firstZ);
          }
          if (lineUpX) {
            _this7.$set(_this7.packs[pack.id], 'x', firstX);
          }
          nextY += spaceBetween + _this7.packs[pack.id].size.height;
        });
      } else {
        alert('Операция невозможна');
      }
    },
    fillDepth: function fillDepth(lineUpY, lineUpX) {
      var _this8 = this;

      var sumOfDepths = this.groupToMove.reduce(function (previousValue, currentValue) {
        return previousValue + _this8.packs[currentValue.id].size.depth;
      }, 0);
      if (sumOfDepths <= this.depth) {
        var spaceBetween = (this.depth - sumOfDepths) / (this.groupToMove.length - 1);
        var nextZ = 0;
        var firstY = this.groupToMove[0].y;
        var firstX = this.groupToMove[0].x;
        this.groupToMove.forEach(function (pack) {
          _this8.$set(_this8.packs[pack.id], 'z', nextZ);
          if (lineUpY) {
            _this8.$set(_this8.packs[pack.id], 'y', firstY);
          }
          if (lineUpX) {
            _this8.$set(_this8.packs[pack.id], 'x', firstX);
          }
          nextZ -= spaceBetween + _this8.packs[pack.id].size.depth;
        });
      } else {
        alert('Операция невозможна');
      }
    },
    stackWidth: function stackWidth() {
      var _this9 = this;

      this.groupToMove.forEach(function (pack) {
        return _this9.movePackToLeft(pack);
      });
    },
    stackHeight: function stackHeight() {
      var _this10 = this;

      this.groupToMove.forEach(function (pack) {
        return _this10.movePackToBottom(pack);
      });
    },
    stackDepth: function stackDepth() {
      var _this11 = this;

      this.groupToMove.forEach(function (pack) {
        return _this11.movePackToFront(pack);
      });
    }
  },
  computed: {
    width: function width() {
      return this.initWidth * this.currentCameraZoom;
    },
    height: function height() {
      return this.initHeight * this.currentCameraZoom;
    },
    depth: function depth() {
      return this.initDepth * this.currentCameraZoom;
    },
    shelfStyle: function shelfStyle() {
      return {
        left: this.left + 'px',
        top: this.top + 'px',
        width: this.width + 'px',
        height: this.height + 'px',
        transform: 'rotateX(' + this.cameraViews[this.currentCameraView].rotationX + 'deg) rotateY(' + this.cameraViews[this.currentCameraView].rotationY + 'deg)',
        transition: this.screenshot ? 'transform 0s linear' : 'transform 1s linear',
        transformStyle: this.screenshot ? '' : 'preserve-3d'
      };
    },
    containerStyle: function containerStyle() {
      return {};
    },
    leftSide: function leftSide() {
      return {
        width: this.height + 'px',
        height: this.depth + 'px',
        transform: 'translate3d(0, 0,  ' + -this.depth + 'px) rotateY(-90deg) rotateZ(-90deg)'
      };
    },
    bottomSide: function bottomSide() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px',
        transform: 'translate3d(0, 0, 0) rotate3d(1, 0, 0, -90deg)'
      };
    },
    topSide: function topSide() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px',
        transform: 'translate3d(0, 0, 0) rotate3d(1, 0, 0, -90deg)'
      };
    },
    rightSide: function rightSide() {
      return {
        width: this.height + 'px',
        height: this.depth + 'px',
        transform: 'translate3d(0, 0, ' + -this.depth + 'px) rotateY(90deg) rotateZ(90deg)'
      };
    },
    viewbox: function viewbox() {
      return '0, 0, ' + this.shelfContourMaxX + ', ' + this.shelfContourMaxY;
    }
  },
  created: function created() {
    var _this12 = this;

    this.loadShelf();

    window.addEventListener('keydown', this.spacePressed);
    window.addEventListener('keyup', this.spaceUp);

    var that = this;
    this.$parent.$on('addProduct', function (product) {
      _this12.addProduct(product);
    });

    this.$parent.$on('save', function () {
      that.save();
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('keydown', this.spacePressed);
    window.removeEventListener('keyup', this.spaceUp);

    this.$parent.$off('addProduct');
    this.$parent.$off('save');
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2canvas__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_html2canvas__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-unused-vars, eslint-disable max-len, no-mixed-operators, no-param-reassign, max-len */




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'shelf',
  props: {
    id: {
      type: String,
      required: true
    },
    x: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data: function data() {
    return {
      packs: [],
      whatToMove: null,
      groupToMove: [],
      zIndex: 0,
      spaceIsPressed: false,
      mousePositionBaked: null,
      diffX: 0,
      diffY: 0,
      left: 0,
      top: 0,
      currentCameraView: 'right',
      screenshot: false,
      cameraViews: {
        right: { title: 'Справа', id: 'right', rotationX: -20, rotationY: -20 },
        top: { title: 'Сверху', id: 'top', rotationX: -91, rotationY: 0 },
        back: { title: 'Сзади', id: 'back', rotationX: 0, rotationY: 180 },
        front: { title: 'Фронт', id: 'front', rotationX: -10, rotationY: 0 },
        leftBottom: { title: 'Слева снизу', id: 'leftBottom', rotationX: 20, rotationY: 20 }
      },
      currentCameraZoom: 2,
      previousCameraZoom: 2,
      cameraZooms: {
        right: { title: '25%', value: 1 },
        top: { title: '50%', value: 2 },
        back: { title: '75%', value: 3 },
        front: { title: '100%', value: 4 }
      },
      shelfContour: '',
      shelfWidth: 0,
      shelfHeight: 0,
      shelfContourMaxX: 0,
      shelfContourMaxY: 0,
      initWidth: 0,
      initHeight: 0,
      initDepth: 0,
      topSideIsVisible: true,
      bottomSideIsVisible: true
    };
  },

  watch: {
    currentCameraZoom: function currentCameraZoom(newCameraZoom) {
      var _this = this;

      this.packs.forEach(function (pack) {
        pack.x = pack.x / _this.previousCameraZoom * newCameraZoom;
        pack.y = pack.y / _this.previousCameraZoom * newCameraZoom;
        pack.z = pack.z / _this.previousCameraZoom * newCameraZoom;
      });
    }
  },
  methods: {
    loadShelf: function loadShelf() {
      var _this2 = this;

      var that = this;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('/api/v2/shelfs/' + this.id + '/').then(function (response) {
        that.isLoading = false;
        _this2.makeShelf(response.data);
      });
    },
    makeShelf: function makeShelf(response) {
      var _this3 = this;

      this.$store.commit('shelf', response);
      this.packs = [];

      this.initWidth = response.rack.prototype.width;
      this.initHeight = (response.rack.prototype.height - response.rack.prototype.firstShelfY) / response.rack.prototype.shelfCount;
      this.initDepth = response.rack.prototype.depth;

      this.shelfContour = response.rack.prototype.contour.map(function (element) {
        _this3.shelfContourMaxX = Math.max(_this3.shelfContourMaxX, element.x);
        _this3.shelfContourMaxY = Math.max(_this3.shelfContourMaxY, element.y);
        return element.x + ' ' + element.y;
      }).join(' ');

      this.shelfWidth = response.rack.prototype.width;
      this.shelfHeight = response.rack.prototype.depth;

      if (response.items.length > 0) {
        response.items.forEach(function (element, key) {
          var photos = {};

          if (element.product.photos.length > 0) {
            photos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(element.product.photos.map(function (o) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, o.side, o.photo400);
            })));
          } else {
            photos = {
              FRONT: '',
              BACK: '',
              TOP: '',
              RIGHT: '',
              LEFT: '',
              BOTTOM: ''
            };
          }
          var pack = {
            pos: element.orientation === 'DEFAULT' ? 0 : 1,
            width: element.product.width,
            initHeight: element.product.height,
            initDepth: element.product.depth,
            initFrontImg: photos.FRONT || '',
            initBackImg: photos.BACK || '',
            initTopImg: photos.TOP || '',
            initRightImg: photos.RIGHT || '',
            initLeftImg: photos.LEFT || '',
            initBottomImg: photos.BOTTOM || '',
            dominantColor: element.product.dominantColor || '',
            isMirrored: false,
            x: element.x,
            y: element.y,
            z: element.z,
            zIndex: 1,
            product: element.product.id,
            selected: false,
            size: {},
            existedId: element.id,
            existed: true
          };

          _this3.packs.push(pack);
        });
      }
    },
    spacePressed: function spacePressed(e) {
      if (e.keyCode === 32) {
        if (e.target.tagName.toUpperCase() === 'BODY') {
          e.preventDefault();
          this.spaceIsPressed = true;
          this.whatToMove = null;
        }
      }
    },
    spaceUp: function spaceUp(e) {
      if (e.keyCode === 32) {
        this.spaceIsPressed = false;
        this.mousePositionBaked = null;
      }
    },
    mousedownShelf: function mousedownShelf(e) {
      if (this.spaceIsPressed) {
        e.stopPropagation();
        this.mousePositionBaked = {
          x: e.pageX,
          y: e.pageY,
          shelfLeft: this.left,
          shelfTop: this.top
        };
      }
    },
    mousedownPack: function mousedownPack(e) {
      // if (this.whatToMove === null) {
      this.whatToMove = e;
      // } else {
      //   this.whatToMove = null;
      // }
    },
    mousemove: function mousemove(e) {
      var _this4 = this;

      if (this.whatToMove !== null) {
        if (this.whatToMove.side === 'front') {
          //

          if (this.groupToMove.length === 0) {
            this.groupToMove.push(this.whatToMove);
          }

          var yChange = 0;
          var xChange = 0;

          this.groupToMove.filter(function (pack) {
            return pack.id === _this4.whatToMove.id;
          }).forEach(function (pack) {
            var topSidePos = e.clientY - _this4.whatToMove.offsetY;
            var maxTopSidePos = _this4.height - _this4.packs[_this4.whatToMove.id].size.height;

            var leftSidePos = e.clientX - _this4.whatToMove.offsetX;
            var maxLeftSidePos = _this4.width - _this4.packs[_this4.whatToMove.id].size.width;

            var yNewPos = Math.max(0, Math.min(topSidePos, maxTopSidePos));
            var xNewPos = Math.max(0, Math.min(leftSidePos, maxLeftSidePos));

            yChange = _this4.packs[_this4.whatToMove.id].y - yNewPos;
            xChange = _this4.packs[_this4.whatToMove.id].x - xNewPos;

            _this4.$set(_this4.packs[_this4.whatToMove.id], 'y', yNewPos);
            _this4.$set(_this4.packs[_this4.whatToMove.id], 'x', xNewPos);
          });

          this.groupToMove.filter(function (pack) {
            return pack.id !== _this4.whatToMove.id;
          }).forEach(function (pack) {
            _this4.$set(_this4.packs[pack.id], 'y', _this4.packs[pack.id].y - yChange);
            _this4.$set(_this4.packs[pack.id], 'x', _this4.packs[pack.id].x - xChange);
          });
        } else {
          this.packs[this.whatToMove.id].z = Math.min(0, e.clientY - this.whatToMove.offsetZ);
        }
      } else if (this.spaceIsPressed && this.mousePositionBaked !== null) {
        this.left = this.mousePositionBaked.shelfLeft - (this.mousePositionBaked.x - e.pageX);
        this.top = this.mousePositionBaked.shelfTop - (this.mousePositionBaked.y - e.pageY);
      }
    },
    mouseup: function mouseup(e) {
      this.whatToMove = null;
      if (this.groupToMove.length === 1 && !e.altKey) {
        this.groupToMove = [];
      }
    },
    mouseleave: function mouseleave(e) {
      this.whatToMove = null;
    },
    packSizeCalculated: function packSizeCalculated(e) {
      this.packs[e.id].size = e.size;
    },
    removePack: function removePack(ind) {
      this.packs.splice(ind, 1);
    },
    rotate: function rotate(ind) {
      this.$set(this.packs[ind], 'pos', this.packs[ind].pos === 0 ? 1 : 0);
    },
    addProduct: function addProduct(product) {
      var photos = {};

      if (product.photos.edges.length > 0) {
        photos = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default.a.apply(Object, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(product.photos.edges.map(function (o) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, o.node.side, o.node.photo400);
        })));
      } else {
        photos = {
          FRONT: '',
          BACK: '',
          TOP: '',
          RIGHT: '',
          LEFT: '',
          BOTTOM: ''
        };
      }

      var pack = {
        pos: 0,
        width: product.width,
        initHeight: product.height,
        initDepth: product.depth,
        initFrontImg: photos.FRONT || '',
        initBackImg: photos.BACK || '',
        initTopImg: photos.TOP || '',
        initRightImg: photos.RIGHT || '',
        initLeftImg: photos.LEFT || '',
        initBottomImg: photos.BOTTOM || '',
        isMirrored: false,
        x: 0,
        y: 0,
        z: 0,
        zIndex: 1,
        product: product.id,
        selected: false,
        size: {},
        existed: false
      };

      this.packs.push(pack);
    },
    save: function save() {
      //
    },
    click: function click(e) {
      //
    }
  },
  computed: {
    width: function width() {
      return this.initWidth * this.currentCameraZoom;
    },
    height: function height() {
      return this.initHeight * this.currentCameraZoom;
    },
    depth: function depth() {
      return this.initDepth * this.currentCameraZoom;
    },
    shelfStyle: function shelfStyle() {
      return {
        left: this.left + 'px',
        top: this.top + 'px',
        width: this.width + 'px',
        height: this.height + 'px',
        transform: 'rotateX(' + this.cameraViews[this.currentCameraView].rotationX + 'deg) rotateY(' + this.cameraViews[this.currentCameraView].rotationY + 'deg)',
        transition: this.screenshot ? 'transform 0s linear' : 'transform 1s linear',
        transformStyle: this.screenshot ? '' : 'preserve-3d'
      };
    },
    containerStyle: function containerStyle() {
      return {};
    },
    leftSide: function leftSide() {
      return {
        width: this.height + 'px',
        height: this.depth + 'px',
        transform: 'translate3d(0, 0,  ' + -this.depth + 'px) rotateY(-90deg) rotateZ(-90deg)'
      };
    },
    bottomSide: function bottomSide() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px',
        transform: 'translate3d(0, 0, 0) rotate3d(1, 0, 0, -90deg)'
      };
    },
    topSide: function topSide() {
      return {
        width: this.width + 'px',
        height: this.depth + 'px',
        transform: 'translate3d(0, 0, 0) rotate3d(1, 0, 0, -90deg)'
      };
    },
    rightSide: function rightSide() {
      return {
        width: this.height + 'px',
        height: this.depth + 'px',
        transform: 'translate3d(0, 0, ' + -this.depth + 'px) rotateY(90deg) rotateZ(90deg)'
      };
    },
    viewbox: function viewbox() {
      return '0, 0, ' + this.shelfContourMaxX + ', ' + this.shelfContourMaxY;
    }
  },
  created: function created() {
    var _this5 = this;

    this.loadShelf();

    window.addEventListener('keydown', this.spacePressed);
    window.addEventListener('keyup', this.spaceUp);

    var that = this;
    this.$parent.$on('addProduct', function (product) {
      _this5.addProduct(product);
    });

    this.$parent.$on('save', function () {
      that.save();
    });
  },
  destroyed: function destroyed() {
    window.removeEventListener('keydown', this.spacePressed);
    window.removeEventListener('keyup', this.spaceUp);

    this.$parent.$off('addProduct');
    this.$parent.$off('save');
  }
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-add',
  created: function created() {
    this.loadPharmacies();
    this.loadUser();
  },

  methods: {
    loadPharmacies: function loadPharmacies() {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/pharmacies/?is_template=false').then(function (response) {
        that.pharmacies = response.data;
      });
    },
    loadUser: function loadUser() {
      if (this.user !== 'add') {
        var self = this;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/users/' + self.user).then(function (response) {
          var user = response.data;
          self.pharmacy = user.pharmacy.id;
          self.lastName = user.lastName;
          self.firstName = user.firstName;
          self.email = user.email;
        });
      }
    },
    save: function save() {
      var data = {
        pharmacy: this.pharmacy,
        lastName: this.lastName,
        firstName: this.firstName,
        email: this.email,
        password: this.password
      };

      var self = this;

      if (this.user !== 'add') {
        if (data.password === '') {
          delete data.password;
        }
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.patch('/api/v2/users/' + self.user, data).then(function () {
          self.returnBack();
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/api/v2/users/', data).then(function () {
          self.returnBack();
        });
      }
    },
    returnBack: function returnBack() {
      this.$router.push('../');
    }
  },
  data: function data() {
    return {
      pharmacies: [],
      pharmacy: '',
      lastName: '',
      firstName: '',
      email: '',
      password: '',
      user: this.$route.params.user
    };
  },

  components: { selectMaterial: __WEBPACK_IMPORTED_MODULE_1__html_SelectMaterial___default.a }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reports',
  created: function created() {
    this.loadVersions();
  },

  methods: {
    loadVersions: function loadVersions() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/api/v2/users/?role=PM').then(function (response) {
        self.isLoading = false;
        self.users = response.data;
      });
    },
    save: function save() {}
  },
  data: function data() {
    return {
      users: []
    };
  }
});

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-447fd5fd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(138),
  /* template */
  __webpack_require__(257),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eaa3e200",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(139),
  /* template */
  __webpack_require__(252),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ac802210",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen",
    attrs: {
      "title": ""
    }
  }, [_c('router-link', {
    staticClass: "close",
    attrs: {
      "to": "../../"
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v("Заменить эталонной")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Аптека",
      "possibleValues": _vm.pharmaciesList,
      "allowSearch": true
    },
    on: {
      "select": function($event) {
        _vm.pharmacy = $event
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Стеллаж",
      "possibleValues": _vm.rackList
    },
    on: {
      "select": function($event) {
        _vm.rack = $event
      }
    }
  })], 1), _vm._v(" "), _c('p', [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Полка",
      "possibleValues": _vm.shelfList
    },
    on: {
      "select": function($event) {
        _vm.shelf = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.link()
      }
    }
  }, [_vm._v("Копировать")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-edit"
  }, [_c('div', {
    staticClass: "product-edit__content"
  }, [_c('router-link', {
    staticClass: "close",
    attrs: {
      "to": "/products/"
    }
  }, [_vm._v("Закрыть")]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__title"
  }, [_vm._v(_vm._s(_vm.product.title))]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__props"
  }, [_c('div', {
    staticClass: "product-edit__prop"
  }, [_vm._v("ID: " + _vm._s(_vm.product.groupId))]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__prop"
  }, [_vm._v("Кластер: " + _vm._s(_vm.product.cluster ? _vm.product.cluster.title : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__two-cols"
  }, [_c('div', {
    staticClass: "product-edit__inputs"
  }, [_c('div', {
    staticClass: "product-edit__size form-block"
  }, [_c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Размер")]), _vm._v(" "), _c('input-material', {
    attrs: {
      "parentClass": "inline",
      "label": "Ширина",
      "type": "number",
      "valueNumber": _vm.product.width
    },
    on: {
      "inputNumber": function($event) {
        _vm.width = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('input-material', {
    attrs: {
      "parentClass": "inline",
      "label": "Высота",
      "type": "number",
      "valueNumber": _vm.product.height
    },
    on: {
      "inputNumber": function($event) {
        _vm.height = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('input-material', {
    attrs: {
      "parentClass": "inline",
      "label": "Глубина",
      "type": "number",
      "valueNumber": _vm.product.depth
    },
    on: {
      "inputNumber": function($event) {
        _vm.depth = $event
      }
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Фотографии упаковки")]), _vm._v(" "), _c('div', {
    staticClass: "pictures"
  }, [_c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.FRONT,
      "type": "FRONT",
      "label": "Перед"
    },
    on: {
      "uploaded": _vm.frontUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.TOP,
      "type": "TOP",
      "label": "Верх"
    },
    on: {
      "uploaded": _vm.topUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.RIGHT,
      "type": "RIGHT",
      "label": "Правая стенка"
    },
    on: {
      "uploaded": _vm.rightUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.LEFT,
      "type": "LEFT",
      "label": "Левая стенка"
    },
    on: {
      "uploaded": _vm.leftUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.BACK,
      "type": "BACK",
      "label": "Задняя стенка"
    },
    on: {
      "uploaded": _vm.backUploaded
    }
  }), _vm._v(" "), _c('drop-zone', {
    attrs: {
      "id": _vm.$route.params.id,
      "productId": _vm.$route.params.id,
      "initImage": _vm.photos.BOTTOM,
      "type": "BOTTOM",
      "label": "Низ"
    },
    on: {
      "uploaded": _vm.bottomUploaded
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__image"
  }, [_c('div', {
    staticClass: "product-edit__change-camera"
  }, _vm._l((_vm.cameraViews), function(view) {
    return _c('div', {
      staticClass: "camera-angle",
      class: [{
        active: (view.id === _vm.currentCameraView)
      }, view.id],
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentCameraView = view.id
        }
      }
    }, [_vm._v(_vm._s(view.title) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "zoom"
  }, _vm._l((_vm.cameraZooms), function(zoom) {
    return _c('div', {
      staticClass: "zoom__item",
      class: {
        active: (zoom.value === _vm.currentCameraZoom)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.previousCameraZoom = _vm.currentCameraZoom;
          _vm.currentCameraZoom = zoom.value
        }
      }
    }, [_vm._v(_vm._s(zoom.title) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "product-edit__camera",
    style: (_vm.cameraPosition)
  }, [_c('pack', {
    staticClass: "pack-position",
    style: (_vm.packStyle),
    attrs: {
      "initWidth": _vm.previewWidth,
      "initHeight": _vm.previewHeight,
      "initDepth": _vm.previewDepth,
      "initFrontImg": _vm.photos.FRONT,
      "initTopImg": _vm.photos.TOP,
      "initRightImg": _vm.photos.RIGHT,
      "initLeftImg": _vm.photos.LEFT,
      "initBottomImg": _vm.photos.BOTTOM,
      "initBackImg": _vm.photos.BACK,
      "isMirrored": false,
      "x": -110,
      "y": -50,
      "z": 0
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__exit"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("Сохранить и закрыть")]), _vm._v(" "), _c('router-link', {
    staticClass: "close-without-save",
    attrs: {
      "to": "/products/"
    }
  }, [_vm._v("Закрыть без сохранения")])], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-edit-type"
  }, [(_vm.$store.state.user.role == 'HM') ? _c('router-link', {
    staticClass: "pharmacy-edit-type__link",
    attrs: {
      "activeClass": "pharmacy-edit-type__link--current",
      "exact": "",
      "to": ("/pharmacies/" + (_vm.$route.params.id) + "/edit/"),
      "title": ""
    }
  }, [_vm._v("Редактирование")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "pharmacy-edit-type__link",
    attrs: {
      "activeClass": "pharmacy-edit-type__link--current",
      "to": ("/pharmacies/" + (_vm.$route.params.id) + "/info/"),
      "title": ""
    }
  }, [_vm._v("Информация")]), _vm._v(" "), (_vm.$route.path == ("/pharmacies/" + (_vm.$route.params.id) + "/info/")) ? _c('a', {
    staticClass: "pharmacy-edit-type__link",
    staticStyle: {
      "margin-left": "75px"
    },
    attrs: {
      "title": "",
      "href": ("/api/reports/productspharmacy?pharmacyId=" + (_vm.$route.params.id) + "&userId=" + (_vm.$store.state.user.id))
    }
  }, [_vm._v("Отчет по выкладке")]) : _vm._e(), _vm._v(" "), (_vm.$route.path == ("/pharmacies/" + (_vm.$route.params.id) + "/info/") && _vm.$store.state.user.role == 'PM') ? _c('a', {
    staticClass: "pharmacy-edit-type__link",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "title": "",
      "href": ("/api/reports/productspharmacy?diff=Y&pharmacyId=" + (_vm.$route.params.id) + "&userId=" + (_vm.$parent.$parent.user.id))
    }
  }, [_vm._v("Отчет по различиям")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen"
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v(_vm._s(_vm.user === 'add' ? 'Добавление' : 'Редактирование') + " сотрудника")]), _vm._v(" "), _c('div', {
    staticClass: "select-holder"
  }, [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Аптека",
      "possibleValues": _vm.pharmacies,
      "allowSearch": false,
      "selectedValues": _vm.pharmacy
    },
    on: {
      "select": function($event) {
        _vm.pharmacy = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-add-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastName),
      expression: "lastName"
    }],
    staticClass: "pharmacy-add-title__input",
    attrs: {
      "type": "text",
      "placeholder": "Фамилия"
    },
    domProps: {
      "value": (_vm.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-add-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstName),
      expression: "firstName"
    }],
    staticClass: "pharmacy-add-title__input",
    attrs: {
      "type": "text",
      "placeholder": "Имя"
    },
    domProps: {
      "value": (_vm.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.firstName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-add-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "pharmacy-add-title__input",
    attrs: {
      "type": "text",
      "placeholder": "Почта"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-add-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "pharmacy-add-title__input",
    attrs: {
      "type": "password",
      "placeholder": "Пароль"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Сохранить")])])])])
},staticRenderFns: []}

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sub-header"
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "page-title page-title-ph"
  }, [_vm._v(_vm._s(_vm.pharmacy.title) + " ["), _vm._l((_vm.pharmacy.categories), function(category) {
    return _c('span', {
      staticClass: "pharmacy-list-item__cats-item"
    }, [_vm._v(_vm._s(category.title))])
  }), _vm._v("]")], 2), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-header__cats"
  }), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-header__supervisor"
  }), _vm._v(" "), _c('div', {
    staticClass: "header__save"
  }, [(_vm.$route.path.includes(("/pharmacies/" + (_vm.$route.params.id) + "/racks/"))) ? _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#",
      "title": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.print.apply(null, arguments)
      }
    }
  }, [_vm._v("Печать")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.role == 'HM') ? _c('span', [_c('router-link', {
    staticClass: "button button--inverse",
    attrs: {
      "title": "",
      "to": {
        path: ("/pharmacies/" + (_vm.$route.params.id) + "/racks/new/")
      }
    }
  }, [_vm._v("Добавить стеллаж")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#",
      "title": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("Сохранить изменения")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.role == 'PM') ? _c('span', {
    staticClass: "version-info"
  }, [_vm._v("\n\n          Версия " + _vm._s(_vm.pharmacy.version.title) + " [" + _vm._s(_vm.statuses[_vm.pharmacy.version.status]) + "]\n        "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pharmacy.version.status === 'NEW'),
      expression: "pharmacy.version.status === 'NEW'"
    }],
    staticClass: "button",
    attrs: {
      "href": "#",
      "title": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVersionStatus('SEEN')
      }
    }
  }, [_vm._v("Взять работу")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pharmacy.version.status === 'SEEN'),
      expression: "pharmacy.version.status === 'SEEN'"
    }],
    staticClass: "button",
    attrs: {
      "href": "#",
      "title": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeVersionStatus('DONE')
      }
    }
  }, [_vm._v("Расставлено")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-tabs"
  }, [_c('router-link', {
    staticClass: "header-tabs__link",
    attrs: {
      "activeClass": "header-tabs__link-active",
      "exact": "",
      "to": ("/pharmacies/" + (_vm.$route.params.id) + "/")
    }
  }, [_vm._v("Планировка")]), _vm._v(" "), _c('router-link', {
    staticClass: "header-tabs__link",
    attrs: {
      "activeClass": "header-tabs__link-active",
      "to": ("/pharmacies/" + (_vm.$route.params.id) + "/racks/")
    }
  }, [_vm._v("Стеллажи")])], 1)])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "holder",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "navigation",
    staticStyle: {
      "overflow-y": "scroll"
    },
    attrs: {
      "title": ""
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.selectedRackName) + "\n    ")]), _vm._v(" "), _c('div', {
    ref: "table",
    staticClass: "table"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.products), function(product) {
    return _c('tr', {
      class: {
        'anti-facing': product.noFacing
      }
    }, [_c('td', {
      staticClass: "id"
    }, [_vm._v(_vm._s(product.groupId))]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('td', {
      staticClass: "title"
    }, [_vm._v(_vm._s(product.title) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "group"
    }, [_vm._v(_vm._s(product.cluster ? product.cluster.title : ''))])])
  }), 0)]), _vm._v(" "), (_vm.hasNext) ? _c('a', {
    ref: "nextLink",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadNextPage.apply(null, arguments)
      }
    }
  }, [_vm._v("Еще товары")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "editor-field",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "plan-holder",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "added-racks",
    attrs: {
      "title": ""
    }
  }, _vm._l((_vm.racks), function(rack) {
    return _c('rack-on-plan', {
      attrs: {
        "width": rack.prototype.width,
        "height": rack.prototype.height,
        "depth": rack.prototype.depth,
        "left": rack.startX,
        "top": rack.startY,
        "angle": rack.angle,
        "id": rack.id,
        "title": rack.title,
        "selected": rack.selected,
        "fulfillment": rack.workload,
        "isExt": rack.isExt
      },
      on: {
        "mousedown": _vm.rackClicked,
        "dblclick": _vm.rackDblClicked
      }
    })
  }), 1), _vm._v(" "), _c('svg', [_c('g', [_c('path', {
    attrs: {
      "d": _vm.contour
    }
  }), _vm._v(" "), _vm._l((_vm.partitions), function(partition, index) {
    return _c('path', {
      attrs: {
        "d": partition.str
      }
    })
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "id"
  }, [_vm._v("\n            ID\n\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "photo"
  }, [_vm._v("Фото")]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("\n            Название\n\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "group"
  }, [_vm._v("\n            Кластер\n\n          ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "photo"
  }, [_c('div', {
    staticClass: "photo-item"
  })])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack",
    class: _vm.holderClass,
    style: (_vm.holderWithPx),
    attrs: {
      "title": ""
    },
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
        return _vm.dblClick.apply(null, arguments)
      },
      "click": function($event) {
        $event.preventDefault();
        return _vm.click($event, 'pack')
      }
    }
  }, [_c('div', {
    staticClass: "front side",
    style: (_vm.front),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'front')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'front')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right side",
    style: (_vm.right),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'right')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'right')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top side",
    style: (_vm.top),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'top')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'top')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom side",
    style: (_vm.bottom),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'bottom')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'bottom')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left side",
    style: (_vm.left),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'left')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'left')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back side",
    style: (_vm.back),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'back')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'back')
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "sub-header"
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Сотрудники")]), _vm._v(" "), _c('div', {
    staticClass: "header__save"
  }, [(_vm.$store.state.user.role == 'HM') ? _c('span', [_c('router-link', {
    staticClass: "button button--inverse",
    attrs: {
      "title": "",
      "to": {
        path: "/users/add/"
      }
    }
  }, [_vm._v("Добавить пользователя")])], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "reports-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "reports-list-body"
  }, _vm._l((_vm.users), function(user) {
    return _c('div', {
      staticClass: "report-item-line",
      on: {
        "click": function($event) {
          return _vm.$router.push(((user.id) + "/"))
        }
      }
    }, [_c('div', {
      staticClass: "report-item report-item__pharmacy"
    }, [_vm._v(_vm._s(user.pharmacy != null ? user.pharmacy.title : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__email"
    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__name"
    }, [_vm._v(_vm._s(user.firstName)), _c('br'), _vm._v(_vm._s(user.lastName))])])
  }), 0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports-list-head"
  }, [_c('div', {
    staticClass: "report-item report-item--head report-item__pharmacy"
  }, [_vm._v("Аптека")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__email"
  }, [_vm._v("Почта")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__name"
  }, [_vm._v("Имя")])])
}]}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen"
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v("Добавление стеллажа")]), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-add-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rName),
      expression: "rName"
    }],
    staticClass: "pharmacy-add-title__input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.rName)
    },
    on: {
      "keyup": function() {
        _vm.autoTitleIsOn = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoTitleIsOn),
      expression: "autoTitleIsOn"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "name": "selected-variant",
      "id": "auto"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoTitleIsOn) ? _vm._i(_vm.autoTitleIsOn, null) > -1 : (_vm.autoTitleIsOn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.autoTitleIsOn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoTitleIsOn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoTitleIsOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoTitleIsOn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label label--checkbox",
    attrs: {
      "for": "auto"
    }
  }, [_vm._v("Авто")])]), _vm._v(" "), _c('div', {
    staticClass: "product-edit__size form-block"
  }, [_c('div', {
    staticClass: "rack-countour",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showEditContour.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "rack",
    style: (_vm.rack)
  }), _vm._v(" "), _c('svg', {
    staticClass: "extra-background",
    style: (_vm.rack),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "id": "backgroundimage",
      "name": "backgroundimage",
      "viewBox": _vm.viewbox
    }
  }, [_c('g', {
    attrs: {
      "fill": "none"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path",
      "stroke": "#F79700",
      "stroke-width": "1",
      "points": _vm.shelfContour
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Габариты, мм")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "Ширина",
      "type": "number",
      "valueNumber": _vm.width
    },
    on: {
      "inputNumber": function($event) {
        _vm.width = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "Высота",
      "type": "number",
      "valueNumber": _vm.height
    },
    on: {
      "inputNumber": function($event) {
        _vm.height = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "Глубина",
      "type": "number",
      "valueNumber": _vm.depth
    },
    on: {
      "inputNumber": function($event) {
        _vm.depth = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-block"
  }, [_c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Высота первой полки")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "мм",
      "type": "number",
      "valueNumber": _vm.firstShelf
    },
    on: {
      "inputNumber": function($event) {
        _vm.firstShelf = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-block"
  }, [_c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Количество полок")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "шт",
      "type": "number",
      "valueNumber": _vm.shelfCount
    },
    on: {
      "inputNumber": function($event) {
        _vm.shelfCount = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Сохранить")])])]), _vm._v(" "), (_vm.isInEditContour) ? _c('div', {
    staticClass: "full-screen"
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isInEditContour = false
      }
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "rack-contour-editor-holder",
    on: {
      "mousemove": _vm.mousemove,
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseup
    }
  }, [_c('div', {
    staticClass: "rack-contour-editor",
    style: (_vm.rackEditor)
  }, [_vm._l((_vm.draggablePoints), function(point, index) {
    return _c('draggable-point', {
      attrs: {
        "top": point.y,
        "left": point.x,
        "type": point.type,
        "insertPos": point.insertPos,
        "lineIndex": point.lineIndex,
        "id": point.id
      },
      on: {
        "mousedown": _vm.mousedown,
        "remove": _vm.remove
      }
    })
  }), _vm._v(" "), _c('svg', [_c('g', [_c('path', {
    attrs: {
      "d": _vm.contour
    }
  })]), _vm._v(" "), _vm._l((_vm.guides), function(line) {
    return _c('line', {
      attrs: {
        "x1": line.x1,
        "y1": line.y1,
        "x2": line.x2,
        "y2": line.y2,
        "stroke": "red",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _c('g', _vm._l((_vm.guides), function(line) {
    return _c('text', {
      attrs: {
        "x": (line.x1 + line.x2) / 2 - 30,
        "y": (line.y1 + line.y2) / 2 - 20
      }
    }, [_vm._v("\n              " + _vm._s(Math.sqrt(Math.pow((line.x2 - line.x1), 2) + Math.pow((line.y2 - line.y1), 2))) + " см\n            ")])
  }), 0)], 2)], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isInEditContour = false
      }
    }
  }, [_vm._v("Сохранить")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen"
  }, [(this.loading) ? _c('div', {
    staticClass: "saving"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v("Выберите Аптеки")]), _vm._v(" "), _c('div', {
    staticClass: "select-holder"
  }, [_c('select-material', {
    attrs: {
      "isMulti": true,
      "title": "Аптека",
      "possibleValues": _vm.pharmacies,
      "allowSearch": false
    },
    on: {
      "select": function($event) {
        _vm.pharmaciesSelected = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Отправить")])])])])
},staticRenderFns: []}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen"
  }, [_c('router-link', {
    staticClass: "close",
    attrs: {
      "to": "../../"
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v("Копирование стеллажа")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Аптека",
      "possibleValues": _vm.pharmacies
    },
    on: {
      "select": function($event) {
        _vm.pharmacy = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copy()
      }
    }
  }, [_vm._v("Копировать")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(this.saving) ? _c('div', {
    staticClass: "saving"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "holder",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "navigation",
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticClass: "plan-item__title"
  }, [_vm._v("Планировка помещения")]), _vm._v(" "), _c('div', {
    staticClass: "plan-item-variants"
  }, [_c('a', {
    staticClass: "plan-item-section plan-item-section--wall",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Стены")]), _vm._v(" "), _c('a', {
    staticClass: "plan-item-section plan-item-section--partition",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addPartition.apply(null, arguments)
      }
    }
  }, [_vm._v("Перегородки")])]), _vm._v(" "), _c('div', {
    staticClass: "plan-item__title"
  }, [_vm._v("Расстановка мебели")]), _vm._v(" "), _c('div', {
    staticClass: "shelf-items"
  }, _vm._l((_vm.rackprototypesTransformed), function(rack) {
    return _c('div', {
      staticClass: "shelf-item",
      on: {
        "dblclick": function($event) {
          return _vm.addRack(rack)
        }
      }
    }, [_c('div', {
      staticClass: "shelf-item__icon"
    }, [_c('img', {
      attrs: {
        "src": "/static/shelf-normal.png",
        "width": "16",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "shelf-item__rack-count"
    }, [_vm._v(_vm._s(rack.shelfCount))])]), _vm._v(" "), _c('div', {
      staticClass: "shelf-item__title"
    }, [_vm._v(_vm._s(rack.title) + " " + _vm._s(rack.width) + "x" + _vm._s(rack.height) + "x" + _vm._s(rack.depth) + " мм")]), _vm._v(" "), _c('router-link', {
      staticClass: "shelf-item__edit",
      attrs: {
        "to": ("/racks/" + (rack.id) + "/edit/")
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "editor-field",
    attrs: {
      "title": ""
    },
    on: {
      "mousemove": _vm.mousemove,
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseup
    }
  }, [_c('div', {
    staticClass: "plan-holder",
    attrs: {
      "title": ""
    },
    on: {
      "click": _vm.planHolderClick
    }
  }, [_vm._l((_vm.draggablePoints), function(point, index) {
    return _c('draggable-point', {
      attrs: {
        "top": point.y,
        "left": point.x,
        "type": point.type,
        "insertPos": point.insertPos,
        "lineIndex": point.lineIndex,
        "id": point.id
      },
      on: {
        "mousedown": _vm.mousedown,
        "remove": _vm.remove
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "added-racks"
  }, [_vm._l((_vm.racks), function(rack, key) {
    return _c('rack-on-plan', {
      attrs: {
        "width": rack.prototype.width,
        "depth": rack.prototype.depth,
        "left": rack.startX,
        "top": rack.startY,
        "angle": rack.angle,
        "id": rack.id,
        "title": rack.title,
        "isExt": rack.isExt,
        "sort": rack.sort ? rack.sort : 100,
        "selected": false
      },
      on: {
        "mousedown": _vm.mousedown,
        "contextmenu": _vm.contextmenu,
        "dblclick": function($event) {
          return _vm.removeRack(key)
        }
      }
    })
  }), _vm._v(" "), (_vm.angleVisible) ? _c('div', {
    staticClass: "angle-block",
    style: (_vm.angleBlock)
  }, [_c('div', {
    staticClass: "rack-on-plan__title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rackTitle),
      expression: "rackTitle"
    }],
    staticClass: "title-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rackTitle)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rackTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sort-and-ext"
  }, [_c('div', {
    staticClass: "ext-config"
  }, [_c('label', {
    staticClass: "label label--checkbox",
    attrs: {
      "for": "auto"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Выносной")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isExt),
      expression: "isExt"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "name": "selected-variant",
      "id": "auto"
    },
    domProps: {
      "checked": Array.isArray(_vm.isExt) ? _vm._i(_vm.isExt, null) > -1 : (_vm.isExt)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "change": function($event) {
        var $$a = _vm.isExt,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isExt = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isExt = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isExt = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sort-config"
  }, [_c('label', {
    staticClass: "label label--checkbox",
    attrs: {
      "for": "auto"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("Сортировка")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.rackSort),
      expression: "rackSort",
      modifiers: {
        "number": true
      }
    }],
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.rackSort)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rackSort = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title-and-angle"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.angleValue),
      expression: "angleValue",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "range",
      "min": "0",
      "max": "360",
      "step": "5"
    },
    domProps: {
      "value": (_vm.angleValue)
    },
    on: {
      "__r": function($event) {
        _vm.angleValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "angle-block-value"
  }, [_vm._v(_vm._s(_vm.angleValue) + "˚")])]), _vm._v(" "), _c('p', {
    staticClass: "copy-links"
  }, [_vm._v("\n              Скопировать\n              "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyRackWithItems()
      }
    }
  }, [_vm._v("в эту же")]), _vm._v(" или\n              "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copyRackWithItemsToOtherPharmacy()
      }
    }
  }, [_vm._v("в другую аптеку")])])]) : _vm._e()], 2), _vm._v(" "), _c('svg', [_c('g', [_c('path', {
    attrs: {
      "d": _vm.contour
    }
  }), _vm._v(" "), _vm._l((_vm.partitions), function(partition, index) {
    return _c('path', {
      attrs: {
        "d": partition.str
      }
    })
  })], 2), _vm._v(" "), _vm._l((_vm.guides), function(line) {
    return _c('line', {
      attrs: {
        "x1": line.x1,
        "y1": line.y1,
        "x2": line.x2,
        "y2": line.y2,
        "stroke": "red",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _c('g', _vm._l((_vm.guides), function(line) {
    return _c('text', {
      attrs: {
        "x": (line.x1 + line.x2) / 2 - 30,
        "y": (line.y1 + line.y2) / 2 - 20
      }
    }, [_vm._v("\n              " + _vm._s(Math.sqrt(Math.pow((line.x2 - line.x1), 2) + Math.pow((line.y2 - line.y1), 2))) + " см\n            ")])
  }), 0)], 2)], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drop"
  }, [_c('div', {
    staticClass: "drop-zone",
    style: (_vm.dropStyle),
    on: {
      "drop": function($event) {
        $event.preventDefault();
        return _vm.fileDropped.apply(null, arguments)
      },
      "dragover": function($event) {
        $event.preventDefault();
        return _vm.fileOver.apply(null, arguments)
      },
      "dragleave": _vm.fileLeave
    }
  }, [(!_vm.showImage) ? _c('div', {
    staticClass: "plus-sign"
  }, [_vm._v(_vm._s(_vm.loadPercent))]) : _vm._e(), _vm._v(" "), (_vm.showImage) ? _c('div', {
    staticClass: "image",
    style: (_vm.imageStyle)
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "drop__label"
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "material-select",
    class: _vm.isSmall ? 'material-select--small' : ''
  }, [_c('div', {
    staticClass: "material-select__holder"
  }, [_c('div', {
    staticClass: "material-select__title",
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_vm._v(_vm._s(_vm.showTitle) + " "), _c('div', {
    staticClass: "material-select__state",
    class: _vm.isOpen ? 'material-select__state--open' : ''
  })]), _vm._v(" "), (_vm.allowSearch) ? _c('div', {
    staticClass: "material-select__search",
    class: _vm.isOpen ? '' : 'hide'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "material-select__search-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "material-select__search__close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeSearchBox()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isMulti) ? _c('div', {
    staticClass: "material-select__values",
    class: _vm.isOpen ? '' : 'hide'
  }, _vm._l((_vm.possibleValues), function(val) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedVariants),
        expression: "checkedVariants"
      }],
      staticClass: "material-select__checkbox",
      attrs: {
        "type": "checkbox",
        "id": val.id,
        "name": "selected-variant"
      },
      domProps: {
        "value": val.id,
        "checked": Array.isArray(_vm.checkedVariants) ? _vm._i(_vm.checkedVariants, val.id) > -1 : (_vm.checkedVariants)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checkedVariants,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = val.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedVariants = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedVariants = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedVariants = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "material-select__label material-select__label--checkbox",
      attrs: {
        "for": val.id
      }
    }, [_vm._v(_vm._s(val.title))])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.isMulti) ? _c('div', {
    staticClass: "material-select__values",
    class: _vm.isOpen ? '' : 'hide'
  }, _vm._l((_vm.possibleValuesFiltered), function(val) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedVariants),
        expression: "checkedVariants"
      }],
      staticClass: "material-select__checkbox",
      attrs: {
        "type": "radio",
        "id": _vm.id + '_' + val.id,
        "name": "selected-variant"
      },
      domProps: {
        "value": val.id,
        "checked": _vm._q(_vm.checkedVariants, val.id)
      },
      on: {
        "change": function($event) {
          _vm.checkedVariants = val.id
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "material-select__label material-select__label--radio",
      attrs: {
        "for": _vm.id + '_' + val.id
      }
    }, [_vm._v(_vm._s(val.title))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isMulti) ? _c('div', {
    staticClass: "material-select__selected-values"
  }, _vm._l((_vm.checkedVariants), function(val) {
    return _c('div', {
      staticClass: "material-select__selected-value"
    }, [_vm._v("\n        " + _vm._s(_vm.possibleValuesMapped[val]) + "\n        "), _c('label', {
      attrs: {
        "for": val
      }
    }, [_vm._v("X")])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "sub-header"
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Отчеты и отправка")]), _vm._v(" "), _c('div', {
    staticClass: "header__save"
  }, [_c('a', {
    staticClass: "button button--inverse",
    attrs: {
      "href": "/api/reports/products_pharmacy_global"
    }
  }, [_vm._v("Скачать текущий отчет")]), _vm._v(" "), (_vm.$store.state.user.role == 'HM') ? _c('span', [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('add/')
      }
    }
  }, [_vm._v("Отправить данные")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "reports-list"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "reports-list-body"
  }, _vm._l((_vm.pharmacies), function(pharmacy) {
    return _c('div', {
      staticClass: "report-item-line"
    }, [_c('div', {
      staticClass: "report-item report-item__pharmacy"
    }, [_vm._v(_vm._s(pharmacy.title))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__date"
    }, [_vm._v(_vm._s(pharmacy.version !== null ? pharmacy.version.title : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__groups"
    }, [_vm._v(_vm._s(pharmacy.version !== null ? pharmacy.version.clusterCount : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__facings"
    }, [_vm._v(_vm._s(pharmacy.version !== null ? pharmacy.version.facingCount : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__report"
    }, [_vm._v(_vm._s(pharmacy.version !== null ? _vm.statuses[pharmacy.version.status] : ''))]), _vm._v(" "), _c('div', {
      staticClass: "report-item report-item__report"
    })])
  }), 0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reports-list-head"
  }, [_c('div', {
    staticClass: "report-item report-item--head report-item__pharmacy report-item__pharmacy--head"
  }, [_vm._v("Аптека")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__date report-item__date--head"
  }, [_vm._v("Дата "), _c('br'), _vm._v("отправки")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__groups report-item__groups--head"
  }, [_vm._v("Товарных "), _c('br'), _vm._v("групп")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__facings report-item__facings--head"
  }, [_vm._v("Показов")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__report report-item__report--head"
  }, [_vm._v("Статус")]), _vm._v(" "), _c('div', {
    staticClass: "report-item report-item--head report-item__report report-item__report--head"
  })])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "material-input-holder",
    class: _vm.parentClass
  }, [(_vm.type === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueMutatedStr),
      expression: "valueMutatedStr"
    }],
    staticClass: "material-input",
    class: _vm.labelClass,
    attrs: {
      "type": "text",
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.valueMutatedStr)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueMutatedStr = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueMutatedStr),
      expression: "valueMutatedStr"
    }],
    staticClass: "material-input",
    class: _vm.labelClass,
    attrs: {
      "type": "email",
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.valueMutatedStr)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueMutatedStr = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueMutatedStr),
      expression: "valueMutatedStr"
    }],
    staticClass: "material-input",
    class: _vm.labelClass,
    attrs: {
      "type": "password",
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.valueMutatedStr)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueMutatedStr = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'number') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueMutatedNumber),
      expression: "valueMutatedNumber"
    }],
    staticClass: "material-input",
    class: _vm.labelClass,
    attrs: {
      "type": "number",
      "id": _vm.id
    },
    domProps: {
      "value": (_vm.valueMutatedNumber)
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueMutatedNumber = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "material-input-label",
    class: _vm.labelClass,
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth"
  }, [_c('h1', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('div', {
    staticClass: "auth-block"
  }, [_c('h2', [_vm._v("Вход в систему")]), _vm._v(" "), _c('div', {
    staticClass: "auth-field"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Электронная почта")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "id": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "auth-field"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Пароль")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "id": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.logMe.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "auth-field"
  }, [_c('label', {
    attrs: {
      "for": "actButton"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button action-button",
    attrs: {
      "href": "#",
      "id": "actButton"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logMe.apply(null, arguments)
      }
    }
  }, [_vm._v("Войти")])])])])
},staticRenderFns: []}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "holder"
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "navigation",
    class: _vm.roleClass
  }, [_c('div', {
    staticClass: "breadcrumbs"
  }, [_vm._v("\n      " + _vm._s(_vm.$store.getters.rackShelfInfo) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "width": "300px"
    }
  }, [_c('material-input', {
    attrs: {
      "parentClass": "",
      "label": "ID или Название",
      "valueStr": _vm.searchStr
    },
    on: {
      "inputStr": _vm.inputStr
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "font-size": "14px",
      "padding-top": "10px"
    }
  }, [(_vm.$store.state.user.role === 'PM') ? _c('div', [_c('label', {
    attrs: {
      "for": "onlyNew"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyAdd),
      expression: "onlyAdd"
    }],
    attrs: {
      "type": "checkbox",
      "id": "onlyNew"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyAdd) ? _vm._i(_vm.onlyAdd, null) > -1 : (_vm.onlyAdd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyAdd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyAdd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyAdd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyAdd = $$c
        }
      }
    }
  }), _vm._v(" Только новые")]), _vm._v("\n                   \n              "), _c('label', {
    attrs: {
      "for": "onlyLost"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyRemove),
      expression: "onlyRemove"
    }],
    attrs: {
      "type": "checkbox",
      "id": "onlyLost"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyRemove) ? _vm._i(_vm.onlyRemove, null) > -1 : (_vm.onlyRemove)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyRemove,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyRemove = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyRemove = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyRemove = $$c
        }
      }
    }
  }), _vm._v(" Только ушедшие")]), _vm._v("\n                   \n            ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('div', [_c('label', {
    attrs: {
      "for": "onlyNeedRemoval"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyRemove),
      expression: "onlyRemove"
    }],
    attrs: {
      "type": "checkbox",
      "id": "onlyNeedRemoval"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyRemove) ? _vm._i(_vm.onlyRemove, null) > -1 : (_vm.onlyRemove)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyRemove,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyRemove = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyRemove = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyRemove = $$c
        }
      }
    }
  }), _vm._v("\n                Только те, что надо убрать")]), _vm._v("\n                   \n              "), _c('label', {
    attrs: {
      "for": "onlyNeedPlacement"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.onlyAdd),
      expression: "onlyAdd"
    }],
    attrs: {
      "type": "checkbox",
      "id": "onlyNeedPlacement"
    },
    domProps: {
      "checked": Array.isArray(_vm.onlyAdd) ? _vm._i(_vm.onlyAdd, null) > -1 : (_vm.onlyAdd)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.onlyAdd,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.onlyAdd = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.onlyAdd = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.onlyAdd = $$c
        }
      }
    }
  }), _vm._v("\n                Только те, что еще не расставлены")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "table-holder"
  }, [_c('table', [_c('thead', [_c('tr', [_c('td', {
    staticClass: "id"
  }, [_vm._v("\n            ID\n\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "photo"
  }, [_vm._v("Фото")]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("\n            Название\n\n          ")]), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('td', {
    staticClass: "group"
  }, [_vm._v("\n            Кластер\n\n          ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.productList), function(product) {
    return _c('tr', {
      class: {
        'anti-facing': product.noFacing
      }
    }, [_c('td', {
      staticClass: "id"
    }, [_vm._v(_vm._s(product.groupId))]), _vm._v(" "), _c('td', {
      staticClass: "photo"
    }, [_c('div', {
      staticClass: "photo-item",
      style: ({
        'background-image': ("url('" + (product.photos.FRONT) + "')")
      })
    })]), _vm._v(" "), _c('td', {
      staticClass: "title",
      on: {
        "dblclick": function($event) {
          return _vm.add(product)
        }
      }
    }, [_vm._v(_vm._s(product.title) + "\n          ")]), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('td', {
      staticClass: "group"
    }, [_vm._v(_vm._s(product.cluster ? product.cluster.title : ''))]) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.next != null) ? _c('a', {
    ref: "next",
    staticClass: "more",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadNextPage.apply(null, arguments)
      }
    }
  }, [_vm._v("Еще товары")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "editor-field",
    class: _vm.roleClass
  }, [(_vm.$store.state.user.role === 'HM') ? _c('shelf', {
    attrs: {
      "initWidth": 800,
      "initHeight": 400,
      "initDepth": 300,
      "x": 0,
      "zoom": 2,
      "id": this.$route.params.shelf
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.role !== 'HM') ? _c('shelfView', {
    attrs: {
      "initWidth": 800,
      "initHeight": 400,
      "initDepth": 300,
      "x": 0,
      "zoom": 2,
      "id": this.$route.params.shelf
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen",
    attrs: {
      "title": ""
    }
  }, [_c('router-link', {
    staticClass: "close",
    attrs: {
      "to": "../../"
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v("Копирование полки")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Аптека",
      "possibleValues": _vm.pharmaciesList,
      "allowSearch": true
    },
    on: {
      "select": function($event) {
        _vm.pharmacy = $event
      }
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Стеллаж",
      "possibleValues": _vm.rackList
    },
    on: {
      "select": function($event) {
        _vm.rack = $event
      }
    }
  })], 1), _vm._v(" "), _c('p', [_c('select-material', {
    attrs: {
      "isMulti": false,
      "title": "Полка",
      "possibleValues": _vm.shelfList
    },
    on: {
      "select": function($event) {
        _vm.shelf = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.copy()
      }
    }
  }, [_vm._v("Копировать")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen"
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "add-pharmacy-wrapper"
  }, [_c('div', {
    staticClass: "pre-title"
  }, [_vm._v("Редактирование стеллажа")]), _vm._v(" "), _c('div', {
    staticClass: "pharmacy-add-title"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rName),
      expression: "rName"
    }],
    staticClass: "pharmacy-add-title__input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.rName)
    },
    on: {
      "keyup": function() {
        _vm.autoTitleIsOn = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.rackprototype.racks.count === 0) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoTitleIsOn),
      expression: "autoTitleIsOn"
    }],
    staticClass: "checkbox",
    attrs: {
      "type": "checkbox",
      "name": "selected-variant",
      "id": "auto"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoTitleIsOn) ? _vm._i(_vm.autoTitleIsOn, null) > -1 : (_vm.autoTitleIsOn)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.autoTitleIsOn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoTitleIsOn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoTitleIsOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoTitleIsOn = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label label--checkbox",
    attrs: {
      "for": "auto"
    }
  }, [_vm._v("Авто")])]) : _vm._e()]), _vm._v(" "), (_vm.rackprototype.racks.count === 0) ? _c('div', [_c('div', {
    staticClass: "product-edit__size form-block"
  }, [_c('div', {
    staticClass: "rack-countour",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showEditContour.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "rack",
    style: (_vm.rack)
  }), _vm._v(" "), _c('svg', {
    staticClass: "extra-background",
    style: (_vm.rack),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "id": "backgroundimage",
      "name": "backgroundimage",
      "viewBox": _vm.viewbox
    }
  }, [_c('g', {
    attrs: {
      "fill": "none"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path",
      "stroke": "#F79700",
      "stroke-width": "1",
      "points": _vm.shelfContour
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Габариты, мм")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "Ширина",
      "type": "number",
      "valueNumber": _vm.width
    },
    on: {
      "inputNumber": function($event) {
        _vm.width = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "Высота",
      "type": "number",
      "valueNumber": _vm.height
    },
    on: {
      "inputNumber": function($event) {
        _vm.height = $event
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("x")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "Глубина",
      "type": "number",
      "valueNumber": _vm.depth
    },
    on: {
      "inputNumber": function($event) {
        _vm.depth = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-block"
  }, [_c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Высота первой полки")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "мм",
      "type": "number",
      "valueNumber": _vm.firstShelf
    },
    on: {
      "inputNumber": function($event) {
        _vm.firstShelf = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-block"
  }, [_c('div', {
    staticClass: "form__block-title"
  }, [_vm._v("Количество полок")]), _vm._v(" "), _c('material-input', {
    attrs: {
      "parentClass": "inline",
      "label": "шт",
      "type": "number",
      "valueNumber": _vm.shelfCount
    },
    on: {
      "inputNumber": function($event) {
        _vm.shelfCount = $event
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Сохранить")])]), _vm._v(" "), (_vm.rackprototype.racks.count !== 0) ? _c('div', {
    staticClass: "no-edit"
  }, [_c('div', {
    staticClass: "no-edit__title"
  }, [_vm._v("\n      Нельзя редактировать габариты стеллажа, который уже используется в аптеках\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "rack-list"
  }, _vm._l((_vm.rackprototype.racks), function(rack) {
    return _c('div', {
      staticClass: "rack-list-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(rack.title) + " –  "), _c('router-link', {
      staticClass: "shelf-item__edit",
      attrs: {
        "to": ("/pharmacies/" + (rack.pharmacy.id) + "/")
      }
    }, [_vm._v(_vm._s(rack.pharmacy.title))])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.isInEditContour) ? _c('div', {
    staticClass: "full-screen"
  }, [_c('a', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isInEditContour = false
      }
    }
  }, [_c('span', {
    staticClass: "close__title"
  }, [_vm._v("Esc")])]), _vm._v(" "), _c('div', {
    staticClass: "rack-contour-editor-holder",
    on: {
      "mousemove": _vm.mousemove,
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseup
    }
  }, [_c('div', {
    staticClass: "rack-contour-editor",
    style: (_vm.rackEditor)
  }, [_vm._l((_vm.draggablePoints), function(point, index) {
    return _c('draggable-point', {
      attrs: {
        "top": point.y,
        "left": point.x,
        "type": point.type,
        "insertPos": point.insertPos,
        "lineIndex": point.lineIndex,
        "id": point.id
      },
      on: {
        "mousedown": _vm.mousedown,
        "remove": _vm.remove
      }
    })
  }), _vm._v(" "), _c('svg', [_c('g', [_c('path', {
    attrs: {
      "d": _vm.contour
    }
  })]), _vm._v(" "), _vm._l((_vm.guides), function(line) {
    return _c('line', {
      attrs: {
        "x1": line.x1,
        "y1": line.y1,
        "x2": line.x2,
        "y2": line.y2,
        "stroke": "red",
        "stroke-width": "1"
      }
    })
  }), _vm._v(" "), _c('g', _vm._l((_vm.guides), function(line) {
    return _c('text', {
      attrs: {
        "x": (line.x1 + line.x2) / 2 - 30,
        "y": (line.y1 + line.y2) / 2 - 20
      }
    }, [_vm._v("\n              " + _vm._s(Math.sqrt(Math.pow((line.x2 - line.x1), 2) + Math.pow((line.y2 - line.y1), 2))) + " см\n            ")])
  }), 0)], 2)], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isInEditContour = false
      }
    }
  }, [_vm._v("Сохранить")])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "width-wrapper"
  }, [_c('div', {
    ref: "table",
    staticClass: "table"
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "width": "300px"
    }
  }, [_c('material-input', {
    attrs: {
      "parentClass": "",
      "label": "ID или Название",
      "valueStr": _vm.searchStr
    },
    on: {
      "inputStr": _vm.inputStr
    }
  })], 1)]), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.productList), function(product) {
    return _c('tr', {
      class: {
        'anti-facing': product.noFacing
      }
    }, [_c('td', {
      staticClass: "id"
    }, [_vm._v(_vm._s(product.groupId))]), _vm._v(" "), _c('td', {
      staticClass: "photo"
    }, [_c('div', {
      staticClass: "photo-item",
      style: ({
        'background-image': ("url('" + (product.photos.FRONT) + "')")
      })
    })]), _vm._v(" "), _c('td', {
      staticClass: "title",
      on: {
        "dblclick": function($event) {
          return _vm.$router.push({
            path: ("/products/" + (product.id))
          })
        }
      }
    }, [_vm._v(_vm._s(product.title) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "group"
    }, [_vm._v(_vm._s(product.cluster ? product.cluster.title : ''))]), _vm._v(" "), _c('td', {
      staticClass: "group"
    }, [_vm._v(_vm._s(product.heading ? product.heading.title : ''))])])
  }), 0)]), _vm._v(" "), (_vm.next != null) ? _c('a', {
    ref: "nextLink",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadNextPage.apply(null, arguments)
      }
    }
  }, [_vm._v("Еще товары")]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-header"
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Товары")]), _vm._v(" "), _c('div', {
    staticClass: "header__save"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "id"
  }, [_vm._v("\n            ID\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "photo"
  }, [_vm._v("Фото")]), _vm._v(" "), _c('td', {
    staticClass: "title"
  }, [_vm._v("\n            Название\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "group"
  }, [_vm._v("\n            Кластер\n          ")]), _vm._v(" "), _c('td', {
    staticClass: "group"
  }, [_vm._v("\n            Рубрика\n          ")])])])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "rack-list",
    attrs: {
      "title": ""
    }
  }, _vm._l((_vm.racks), function(rack) {
    return _c('div', {
      staticClass: "rack-list-item",
      attrs: {
        "title": ""
      }
    }, [(rack.has_changes && _vm.$store.state.user.role === 'HM') ? _c('div', {
      staticClass: "has-changes"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "rack-list-item__name",
      attrs: {
        "id": rack.id
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/"))
        }
      }
    }, [_vm._v(_vm._s(rack.title))])]), _vm._v(" "), _c('div', {
      staticClass: "rack-list-item__group"
    }), _vm._v(" "), _vm._l((rack.shelfs), function(shelf, index) {
      return _c('div', {
        staticClass: "rack-list-shelf",
        class: shelf.template_shelf !== null ? 'rack-list-shelf--template' : '',
        attrs: {
          "title": ""
        }
      }, [(shelf.has_changes) ? _c('div', {
        staticClass: "has-changes"
      }) : _vm._e(), _vm._v(" "), (shelf.template_shelf === null) ? _c('div', [_c('div', {
        on: {
          "click": function($event) {
            return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/"))
          }
        }
      }, [(_vm.$store.state.user.role === 'HM') ? _c('img', {
        staticClass: "rack-list-shelf__image new-ver",
        attrs: {
          "src": shelf.photo,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "rack-list-shelf__image last-ver",
        attrs: {
          "src": shelf.lastVerPhoto,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "rack-list-shelf__number"
      }, [_vm._v("# " + _vm._s(rack.shelfs.length - (index)))])]), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('div', {
        staticClass: "rack-list-operations-module"
      }, [_c('a', {
        staticClass: "top-nav__link",
        on: {
          "click": function($event) {
            return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/"))
          }
        }
      }, [_vm._v("Перейти")]), _vm._v(" "), _c('a', {
        staticClass: "top-nav__link",
        on: {
          "click": function($event) {
            return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/copy/"))
          }
        }
      }, [_vm._v("Скопировать")]), _vm._v(" "), _c('a', {
        staticClass: "top-nav__link",
        on: {
          "click": function($event) {
            return _vm.$router.push(("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/template/"))
          }
        }
      }, [_vm._v("Заменить эталонной")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (shelf.template_shelf !== null) ? _c('div', [_c('div', {
        on: {
          "click": function($event) {
            return _vm.$router.push(_vm.$store.state.user.role === 'HM' ? ("/pharmacies/" + (shelf.template_shelf.pharmacy) + "/racks/" + (shelf.template_shelf.rack) + "/" + (shelf.template_shelf.id) + "/") : ("/pharmacies/" + _vm.pharmacy + "/racks/" + (rack.id) + "/" + (shelf.id) + "/"))
          }
        }
      }, [(_vm.$store.state.user.role === 'HM') ? _c('img', {
        staticClass: "rack-list-shelf__image new-ver",
        attrs: {
          "src": shelf.template_shelf.photo,
          "alt": ""
        }
      }) : _c('img', {
        staticClass: "rack-list-shelf__image last-ver",
        attrs: {
          "src": shelf.lastVerPhoto,
          "alt": ""
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "rack-list-shelf__number"
      }, [_vm._v("# " + _vm._s(rack.shelfs.length - (index)))])]), _vm._v(" "), (_vm.$store.state.user.role === 'HM') ? _c('div', {
        staticClass: "rack-list-operations-module"
      }, [_c('a', {
        staticClass: "top-nav__link",
        on: {
          "click": function($event) {
            return _vm.removeLink(shelf.id)
          }
        }
      }, [_vm._v("Отменить привязку")])]) : _vm._e()]) : _vm._e()])
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rack-list-navigation",
    class: _vm.navClass
  }, _vm._l((_vm.racks), function(rack) {
    return _c('div', {
      staticClass: "rack-list-navigation-item",
      attrs: {
        "title": ""
      }
    }, [_c('a', {
      staticClass: "rack-list-navigation-item__name",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.navClicked(rack.id)
        }
      }
    }, [_vm._v(_vm._s(rack.title))])])
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editable-td"
  }, [(!_vm.isEditMode) ? _c('div', {
    staticClass: "editable-td__value",
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
        return _vm.onDoubleClick.apply(null, arguments)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.editValue) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.isEditMode) ? _c('div', {
    staticClass: "editable-td__input-holder",
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editValue),
      expression: "editValue"
    }],
    staticClass: "editable-td__input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editValue = $event.target.value
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    style: (_vm.containerStyle),
    on: {
      "!mousedown": function($event) {
        return _vm.mousedownShelf.apply(null, arguments)
      },
      "mousemove": _vm.mousemove,
      "mouseup": function($event) {
        _vm.mousePositionBaked = null
      }
    }
  }, [_c('div', {
    staticClass: "change-view"
  }, [_vm._v("\n        Вид:\n        "), _vm._l((_vm.cameraViews), function(view) {
    return _c('div', {
      staticClass: "view",
      class: {
        active: (view.id === _vm.currentCameraView)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentCameraView = view.id
        }
      }
    }, [_vm._v(_vm._s(view.title) + "\n        ")])
  }), _vm._v("\n\n        Zoom:\n        "), _vm._l((_vm.cameraZooms), function(zoom) {
    return _c('div', {
      staticClass: "view",
      class: {
        active: (zoom.value === _vm.currentCameraZoom)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.previousCameraZoom = _vm.currentCameraZoom;
          _vm.currentCameraZoom = zoom.value
        }
      }
    }, [_vm._v(_vm._s(zoom.title) + "\n        ")])
  }), _vm._v("\n\n        Верхняя полка:\n        "), _c('div', {
    staticClass: "view",
    class: {
      active: _vm.topSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.topSideIsVisible = true
      }
    }
  }, [_vm._v("Вкл")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    class: {
      active: !_vm.topSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.topSideIsVisible = false
      }
    }
  }, [_vm._v("Выкл")]), _vm._v("\n\n        Нижняя полка:\n        "), _c('div', {
    staticClass: "view",
    class: {
      active: _vm.bottomSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.bottomSideIsVisible = true
      }
    }
  }, [_vm._v("Вкл\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    class: {
      active: !_vm.bottomSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.bottomSideIsVisible = false
      }
    }
  }, [_vm._v("Выкл\n        ")]), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shelf",
    style: (_vm.shelfStyle),
    attrs: {
      "id": "shelf",
      "title": ""
    },
    on: {
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseleave
    }
  }, [_c('svg', {
    staticClass: "extra-background",
    style: (_vm.bottomSide),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "id": "backgroundimage",
      "name": "backgroundimage",
      "viewBox": _vm.viewbox
    }
  }, [_c('g', {
    attrs: {
      "fill": "none"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path",
      "stroke": "#F79700",
      "stroke-width": "2",
      "points": _vm.shelfContour
    }
  })])]), _vm._v(" "), (_vm.bottomSideIsVisible) ? _c('div', {
    staticClass: "side bottom",
    style: (_vm.bottomSide)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "side left",
    style: (_vm.leftSide)
  }), _vm._v(" "), _c('div', {
    staticClass: "side right",
    style: (_vm.rightSide)
  }), _vm._v(" "), (_vm.topSideIsVisible) ? _c('div', {
    staticClass: "side top",
    style: (_vm.topSide)
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.packs), function(pack, id) {
    return _c('pack', {
      key: id,
      attrs: {
        "initWidth": pack.width,
        "initHeight": pack.initHeight,
        "initDepth": pack.initDepth,
        "initFrontImg": pack.initFrontImg,
        "initBackImg": pack.initBackImg,
        "initTopImg": pack.initTopImg,
        "initRightImg": pack.initRightImg,
        "initLeftImg": pack.initLeftImg,
        "initBottomImg": pack.initBottomImg,
        "dominantColor": pack.dominantColor,
        "isMirrored": pack.isMirrored,
        "initPos": pack.pos,
        "isDraggable": true,
        "id": id,
        "x": pack.x,
        "y": pack.y,
        "z": pack.z,
        "zoom": _vm.currentCameraZoom,
        "zIndex": pack.zIndex,
        "selected": pack.selected,
        "screenshot": _vm.screenshot
      },
      on: {
        "sizeCalcutated": _vm.packSizeCalculated
      }
    })
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rack-on-plan",
    style: (_vm.style),
    attrs: {
      "title": _vm.title
    },
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
        return _vm.dblclick.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        return _vm.mousedown.apply(null, arguments)
      },
      "contextmenu": function($event) {
        $event.preventDefault();
        return _vm.contextmenu.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "fulfillment",
    style: (_vm.fulfillmentStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('nav', {
    staticClass: "top-nav"
  }, [_c('a', {
    staticClass: "top-nav__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/pharmacies/')
      }
    }
  }, [_vm._v("Аптеки")]), _vm._v(" "), (_vm.user.role == 'HM') ? _c('a', {
    staticClass: "top-nav__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/products/')
      }
    }
  }, [_vm._v("Товары")]) : _vm._e(), _vm._v(" "), (_vm.user.role == 'HM') ? _c('a', {
    staticClass: "top-nav__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/reports/')
      }
    }
  }, [_vm._v("Отчеты и отправка")]) : _vm._e(), _vm._v(" "), (_vm.user.role == 'HM') ? _c('a', {
    staticClass: "top-nav__link",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/users/')
      }
    }
  }, [_vm._v("Сотрудники")]) : _vm._e()]), _vm._v(" "), (_vm.$auth.ready()) ? _c('div', {
    staticClass: "user-info"
  }, [_c('a', {
    staticClass: "header-notificatons",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_vm._v(_vm._s(_vm.user.email) + "\n          "), _c('a', {
    staticClass: "logout_link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$auth.logout();
        _vm.$router.replace({
          path: '/login'
        });
      }
    }
  }, [_vm._v("Выйти")])])]) : _vm._e()])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sub-header"
  }, [_c('div', {
    staticClass: "width-wrapper relative"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Аптеки")]), _vm._v(" "), (_vm.$store.state.user.role == '') ? _c('div', {
    staticClass: "header__save"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "#/pharmacies/new/"
    }
  }, [_vm._v("Добавить аптеку")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "width-wrapper"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "width": "300px",
      "padding-top": "30px"
    }
  }, [_c('material-input', {
    attrs: {
      "parentClass": "",
      "label": "ID или Название",
      "valueStr": _vm.search
    },
    on: {
      "inputStr": _vm.inputStr
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "pharmacies-list"
  }, _vm._l((_vm.pharmaciesList), function(pharmacy) {
    return _c('div', {
      staticClass: "pharmacy-list-item",
      class: pharmacy.is_template ? ' pharmacy-list-item--template' : '',
      on: {
        "click": function($event) {
          return _vm.$router.push('/pharmacies/' + pharmacy.id + '/')
        }
      }
    }, [(pharmacy.has_changes) ? _c('div', {
      staticClass: "pharmacy-list-item__has-changes",
      attrs: {
        "title": "Есть изменения"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pharmacy-list-item__picture"
    }, [_c('svg', {
      attrs: {
        "viewBox": pharmacy.viewbox
      }
    }, [_c('g', [_c('path', {
      attrs: {
        "d": pharmacy.contour
      }
    }), _vm._v(" "), _vm._l((pharmacy.partitions), function(partition, index) {
      return _c('path', {
        attrs: {
          "d": partition.str
        }
      })
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "pharmacy-list-item__description"
    }, [_c('div', {
      staticClass: "pharmacy-list-item__name"
    }, [_vm._v(_vm._s(pharmacy.title))]), _vm._v(" "), (!pharmacy.is_template) ? _c('div', {
      staticClass: "pharmacy-list-item__cats"
    }, [_vm._v("\n            Кат.: "), _vm._l((pharmacy.categories), function(category) {
      return _c('span', {
        staticClass: "pharmacy-list-item__cats-item"
      }, [_vm._v(_vm._s(category.title))])
    })], 2) : _vm._e(), _vm._v(" "), (pharmacy.is_template) ? _c('div', {
      staticClass: "pharmacy-list-item__cats"
    }, [_vm._v("\n            Эталонная аптека\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pharmacy-list-item__facing-info"
    })])])
  }), 0)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category",
    class: this.cssClass
  }, [_c('div', {
    staticClass: "category__sorter"
  }), _vm._v(" "), _c('div', {
    staticClass: "category__title"
  }, [_c('editable-td', {
    attrs: {
      "initValue": this.title
    },
    on: {
      "input": _vm.titleChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "category__date"
  }, [_c('flat-pickr', {
    staticClass: "flat-picker-input",
    attrs: {
      "config": _vm.config
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    style: (_vm.containerStyle),
    on: {
      "!mousedown": function($event) {
        return _vm.mousedownShelf.apply(null, arguments)
      },
      "mousemove": _vm.mousemove,
      "mouseup": function($event) {
        _vm.mousePositionBaked = null
      }
    }
  }, [(this.screenshot) ? _c('div', {
    staticClass: "saving"
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "change-view"
  }, [_vm._v("\n        Вид:\n        "), _vm._l((_vm.cameraViews), function(view) {
    return _c('div', {
      staticClass: "view",
      class: {
        active: (view.id === _vm.currentCameraView)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.currentCameraView = view.id
        }
      }
    }, [_vm._v(_vm._s(view.title) + "\n        ")])
  }), _vm._v("\n\n        Zoom:\n        "), _vm._l((_vm.cameraZooms), function(zoom) {
    return _c('div', {
      staticClass: "view",
      class: {
        active: (zoom.value === _vm.currentCameraZoom)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.previousCameraZoom = _vm.currentCameraZoom;
          _vm.currentCameraZoom = zoom.value
        }
      }
    }, [_vm._v(_vm._s(zoom.title) + "\n        ")])
  }), _vm._v("\n\n        Верхняя полка:\n        "), _c('div', {
    staticClass: "view",
    class: {
      active: _vm.topSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.topSideIsVisible = true
      }
    }
  }, [_vm._v("Вкл")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    class: {
      active: !_vm.topSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.topSideIsVisible = false
      }
    }
  }, [_vm._v("Выкл")]), _vm._v("\n\n        Нижняя полка:\n        "), _c('div', {
    staticClass: "view",
    class: {
      active: _vm.bottomSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.bottomSideIsVisible = true
      }
    }
  }, [_vm._v("Вкл\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    class: {
      active: !_vm.bottomSideIsVisible
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.bottomSideIsVisible = false
      }
    }
  }, [_vm._v("Выкл\n        ")]), _vm._v(" "), _c('br'), _vm._v("\n\n        Растащить:\n        "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по ширине"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillWidth(false, false)
      }
    }
  }, [_vm._v("⇄")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по ширине и выравнять по линиии первой пачки"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillWidth(true, false)
      }
    }
  }, [_c('u', [_vm._v("⇄")])]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по ширине и выравнять по линиии первой пачки"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillWidth(true, true)
      }
    }
  }, [_vm._v("|"), _c('u', [_vm._v("⇄")])]), _vm._v("\n\n         \n\n        "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по высоте"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillHeight.apply(null, arguments)
      }
    }
  }, [_vm._v("⇵")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить по высоте и выравнять по линии первой пачки"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillHeight(true, false)
      }
    }
  }, [_vm._v("|⇵\n        ")]), _vm._v("\n\n         \n\n        "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить в глубину"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillDepth.apply(null, arguments)
      }
    }
  }, [_vm._v("⤪")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Растащить в глубину и выравнять по левому краю первой пачки"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fillDepth(true, true)
      }
    }
  }, [_vm._v("|⤪\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Убрать промежутки между пачками в ширине"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.stackWidth.apply(null, arguments)
      }
    }
  }, [_vm._v("←\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Убрать промежутки между пачками по высоте"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.stackHeight.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            ↓\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "view",
    attrs: {
      "title": "Убрать промежутки между пачками по глубине"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.stackDepth.apply(null, arguments)
      }
    }
  }, [_vm._v("↗\n        ")])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shelf",
    style: (_vm.shelfStyle),
    attrs: {
      "id": "shelf",
      "title": ""
    },
    on: {
      "mouseup": _vm.mouseup,
      "mouseleave": _vm.mouseleave
    }
  }, [_c('svg', {
    staticClass: "extra-background",
    style: (_vm.bottomSide),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "id": "backgroundimage",
      "name": "backgroundimage",
      "viewBox": _vm.viewbox
    }
  }, [_c('g', {
    attrs: {
      "fill": "none"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path",
      "stroke": "#F79700",
      "stroke-width": "2",
      "points": _vm.shelfContour
    }
  })])]), _vm._v(" "), (_vm.bottomSideIsVisible) ? _c('div', {
    staticClass: "side bottom",
    style: (_vm.bottomSide)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "side left",
    style: (_vm.leftSide)
  }), _vm._v(" "), _c('div', {
    staticClass: "side right",
    style: (_vm.rightSide)
  }), _vm._v(" "), (_vm.topSideIsVisible) ? _c('div', {
    staticClass: "side top",
    style: (_vm.topSide)
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.packs), function(pack, id) {
    return _c('pack', {
      key: id,
      attrs: {
        "initWidth": pack.width,
        "initHeight": pack.initHeight,
        "initDepth": pack.initDepth,
        "initFrontImg": pack.initFrontImg,
        "initBackImg": pack.initBackImg,
        "initTopImg": pack.initTopImg,
        "initRightImg": pack.initRightImg,
        "initLeftImg": pack.initLeftImg,
        "initBottomImg": pack.initBottomImg,
        "dominantColor": pack.dominantColor,
        "isMirrored": pack.isMirrored,
        "initPos": pack.pos,
        "isDraggable": true,
        "id": id,
        "x": pack.x,
        "y": pack.y,
        "z": pack.z,
        "zoom": _vm.currentCameraZoom,
        "zIndex": pack.zIndex,
        "selected": pack.selected,
        "screenshot": _vm.screenshot
      },
      on: {
        "click": function($event) {
          return _vm.click($event)
        },
        "moveToSide": function($event) {
          return _vm.moveToSide($event)
        },
        "select": function($event) {
          return _vm.select($event)
        },
        "mousedown": _vm.mousedownPack,
        "removePack": function($event) {
          return _vm.removePack($event)
        },
        "sizeCalcutated": _vm.packSizeCalculated,
        "rotate": function($event) {
          return _vm.rotate($event)
        }
      }
    })
  })], 2)])
},staticRenderFns: []}

/***/ })
],[112]);


// WEBPACK FOOTER //
// static/js/app.3ea069ac9fc5f334a09b.js